import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import setYear from 'date-fns/set_year'
import addMonths from 'date-fns/add_months';
import addDays from "date-fns/add_days";
import lastDayOfMonth from 'date-fns/last_day_of_month';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import differenceInCalendarMonths from 'date-fns/difference_in_calendar_months'
import differenceInCalendarYears from 'date-fns/difference_in_calendar_years'
import {globalfunc} from '../globalfunc.js'
import CryptoJS from 'crypto-js'
import subDays from 'date-fns/sub_days';
import countriesAndTimezone from 'countries-and-timezones';
import { getByUser, getCompany, getTeamByCompany, getUserAll } from './core/cacheService'

export default {
    namespaced: true,
    state: {
      datamembers:[],
      members:[],
      teamall:[],
      inputSearch: '',
      inputSearchArchive: '',
      type:'all',
      page:1,
      pagearchive: 1,
      size_page:10,
      sortfield:'value',
      sortfieldarchive:'archived_timestamp',
      sortorder:'asc',
      sortorderarchive:'desc',
      dataexport:[],
      results: [],
      resultsArchive: [],
      modalMemberData: [],
      membersByKey: [],
      membersArchiveByKey: [],
      bossByKey: [],
      teamByKey: [],
      teamParentByKey: [],
      organizations: [],
      membersArchive: [],
      membersArchiveAll: [],
      incomplete: [],
      loadingMemberTable: true,
      loadingArchiveTable: true,
      supUserByTeam: [],
      houseByKey: [],
      webviewData: [],
      allArchiveData: [],
      managerMembers: [],
      orgChartView: {},
      orgChartModal: {},
      loadingOrgChartView: true,
      riskData:[],
      risk:{},
      starPerformer:{},
      holiday:{},
      date:format(new Date(),"YYYY-MM-DD"),
      loadingLoadMoreData:false,
      powerData:[],
      archivedSchedule:0,
      userArchivedSchedule:[],
      timeZoneOption:[],
      locationOption:[],
      timezone:[],
      // emptyMember:[],
      updateMember:false,
      riskCategory:[],
      recognition:[],
      alignment:[],
      tag:[],
      hashtag:[],
      dataAll:[],
      last_rank_given:0,
      last_rank_received:0,
      last_rank_ratio:0,
      recognitionAll:[],
      personalContext: null,

    },
    mutations: {
      setDataMembers(state:any, result:any) {
        state.datamembers = result
      },
      setAllArchiveData(state:any, result:any) {
        state.allArchiveData = result
      },
      setManagerMembers(state:any, result:any) {
        state.managerMembers = result
      },
      setMember(state:any, result:any) {
        state.members = result
      },
      setTeamall(state:any, result:any) {
        state.teamall = result
      },
      setinputSearch(state:any,value:any) {
        state.inputSearch = value.keyword
        state.type = value.userstatus
      },
      setinputSearchArchive(state:any,value:any) {
        state.inputSearchArchive = value.keyword
      },
      setPage(state:any,result:any) {
        state.page = result
      },
      setPageArchive(state:any,result:any) {
        state.pagearchive = result
      },
      setType(state:any,result:any) {
        state.type = result
      },
      setSortfield(state:any,result:any) {
        state.sortfield = result
      },
      setSortfieldArchive(state:any,result:any) {
        state.sortfieldarchive = result
      },
      setSortorder(state:any,result:any) {
        state.sortorder = result
      },
      setSortorderArchive(state:any,result:any) {
        state.sortorderarchive = result
      },
      setDataExport(state:any, result:any) {
        state.dataexport = result
      },
      setResults(state:any, result:any) {
        state.results = result
      },
      setResultsArchive(state:any, result:any) {
        state.resultsArchive = result
      },
      setModalMemberData(state:any, result:any) {
        state.modalMemberData = result
      },
      setMemberKey(state:any, result:any) {
        state.membersByKey = result
      },
      setMemberArchiveKey(state:any, result:any) {
        state.membersArchiveByKey = result
      },
      setBossKey(state:any, result:any) {
        state.bossByKey = result
      },
      setTeamKey(state:any, result:any) {
        state.teamByKey = result
      },
      setTeamParentKey(state:any, result:any) {
        state.teamParentByKey = result
      },
      setOrganizations(state: any, value: any) {
        state.organizations = value
      },
      setMemberArchive(state: any, value: any) {
        state.membersArchive = value
      },
      setMemberArchiveAll(state: any, value: any) {
        state.membersArchiveAll = value
      },
      setIncomplete(state: any, value: any) {
        state.incomplete = value
      },
      setLoadingMemberTable(state:any, result:any) {
        state.loadingMemberTable = result
      },
      setLoadingArchiveTable(state:any, result:any) {
        state.loadingArchiveTable = result
      },
      setLoadingOrgChartView(state:any, result:any) {
        state.loadingOrgChartView = result
      },
      setsupUserByTeam(state:any, result:any) {
        state.supUserByTeam = result
      },
      setHouseBykey(state:any, result:any) {
        state.houseByKey = result
      },
      setWebViewData(state:any, result:any) {
        state.webviewData = result
      },
      setOrgChartView(state:any, result:any) {
        state.orgChartView = result
      },
      setRisk(state:any, result:any) {
        state.risk = result
    },
      setriskCategory(state:any, result:any) {
        state.riskCategory = result
    },
    setStarPerformer(state:any, result:any) {
        state.starPerformer = result
    },
    setHoliday(state:any, result:any) {
        state.holiday = result
    },
    setLoadingLoadMoreData(state:any, result:any) {
        state.loadingLoadMoreData = result
    },
    setPowerData(state:any, result:any) {
      state.powerData = result
  },
  setArchivedSchedule(state:any, result:any) {
    state.archivedSchedule = result
},
  setUserArchivedSchedule(state:any, result:any) {
  state.userArchivedSchedule = result
  },
  setTimeZoneOption(state:any, result:any) {
    state.timeZoneOption = result
  },
  setTimezone(state:any, result:any) {
    state.timezone = result
  },
  setLocationOption(state:any, result:any) {
    state.locationOption = result
  },
  sethashtag(state:any, result:any) {
    state.hashtag = result
  },
  setRecognitionAll(state:any, result:any) {
    state.recognitionAll = result
  },

  
  // setEmptyMember(state:any, result:any){
  //   state.emptyMember = result
  // },
  setUpdateMember(state:any, result:any){
    state.updateMember = result
  },
  setRecognitionValue(state : any, result : any) {
    state.recognitionValue = result
  },
  setRecognition(state : any, result : any) {
    state.recognition = result
  },
  setAlignment(state : any, result : any) {
      state.alignment = result
  },
  setPersonalContext(state : any, result : any) {
    state.personalContext = result
  },
    },
    actions: {
      getOrganization({ commit,state, rootState }: any) {
        if(state.organizations.length == 0){
          firebase.firestore().collection('organization').where("company", "==", rootState.authen.user.company).get()
          .then(function (querySnapshot) {
            const organizations: Array<any> = [];
            querySnapshot.forEach((doc) => {
              const organization = doc.data()
              organization.key = doc.id
              organizations[organization.team_id] = organization
            });
            commit('setOrganizations', organizations)
          });
        }
      },
      async getTeamParentKeyData({commit,dispatch,state}:any, user:any){
        let teamIn:Array<any> = []
        const teams:Array<any> = [];
        const parent:Array<any> = [];
        try{
          const team = await getTeamByCompany(user.company)
          for(const key in team){
            const u = team[key]
            u.key = key
            u.value = team[key].name
            if(team.sup === undefined){
                team.sup = new Array()
            }
            let teamId = team.key
            let arrTeam = state.organizations[teamId];
            if(arrTeam){
                if (arrTeam.parent) {
                    if (teamIn[teamId] === undefined) {
                        teamIn[teamId] = new Array();
                    }
                    teamIn[teamId][teamId] = true;
                    teamIn[teamId] = globalfunc.getTeamOfParent(arrTeam.parent,teamIn[teamId]);
                    for (const k in teamIn[teamId]) {
                        const userTeam = state.supUserByTeam[k]
                        for (const x in userTeam) {
                          if(userTeam[x].email){
                            let userTeamKey:any = userTeam[x].email.replace(/\./g, "||")
                            team.sup = _.concat(team.sup, state.membersByKey[userTeamKey]);
                          }
                        }
                    }
                }
            }else{
                const userTeam = state.supUserByTeam[teamId]
                for (const x in userTeam) {
                  if(userTeam[x].email){
                    let userTeamKey:any = userTeam[x].email.replace(/\./g, "||")
                    team.sup = _.concat(team.sup, state.membersByKey[userTeamKey]);
                  }
                }
            }
            team.sup = _.sortBy(team.sup, [function(o:any) { return o.firstname; }])
            const boss:any = _.filter(state.bossByKey, { 'team': team.key })
            if(boss.length > 0){
                let email:any = ""
                if(boss.length == 1){
                    email = boss[0].email.replace(/\./g, "||")
                }else{
                    let checkBigBoss = false
                    let arrManager:Array<any> = [];
                    for(const i in boss){
                        let mailBoss:any = boss[i].email.replace(/\./g, "||")
                        if(!state.membersByKey[mailBoss].boss){
                            email = mailBoss.replace(/\./g, "||")
                            checkBigBoss = true
                        }else{
                            arrManager.push({email:state.membersByKey[mailBoss].boss})
                        }
                    }
                    if(!checkBigBoss){
                        const checkCountManager:any = _.filter(arrManager, { 'email': arrManager[0].email })
                        if(arrManager.length == checkCountManager.length){
                            email = arrManager[0].email.replace(/\./g, "||")
                        }else{
                            const bossParent:any = _.filter(state.bossByKey, { 'team': team.parent })
                            if(bossParent.length > 0){
                                email = bossParent[0].email.replace(/\./g, "||")
                            }
                        }
                    }
                }
                if(email && state.membersByKey[email]){
                    team.boss_firstname = state.membersByKey[email].firstname
                    team.boss_lastname = state.membersByKey[email].lastname

                    if(state.membersByKey[email].profilepic_small){
                        team.pic = state.membersByKey[email].profilepic_small;
                    }else if (state.membersByKey[email].profilepic_crop){
                        team.pic = state.membersByKey[email].profilepic_crop;
                    }else if (state.membersByKey[email].profilepic){
                        team.pic = state.membersByKey[email].profilepic;
                    }else {
                        team.pic = '';
                    }
                }else{
                    team.boss_firstname = ''
                    team.boss_lastname = ''
                    team.pic = ''
                }
                
            }else{
                if(team.sup.length > 0){
                    let email:any = ""
                    if(team.sup.length == 1){
                        email = team.sup[0].email.replace(/\./g, "||")
                    }else {
                      let checkInMultipleTeam :any = _.filter(team.sup, { 'team': team.key })
                      if(checkInMultipleTeam.length == 1){
                          email = checkInMultipleTeam[0].email.replace(/\./g, "||")
                      }else{
                        let arrManager:Array<any> = [];
                        for(const i in team.sup){
                            let mailBoss:any = team.sup[i].email.replace(/\./g, "||")
                            if(state.membersByKey[mailBoss].boss){
                                arrManager.push({email:state.membersByKey[mailBoss].boss})
                            }
                        }
                        if(arrManager[0]){
                          const checkCountManager:any = _.filter(arrManager, { 'email': arrManager[0].email })
                          if(arrManager.length == checkCountManager.length){
                              email = arrManager[0].email.replace(/\./g, "||")
                          }else{
                              const bossParent:any = _.filter(state.bossByKey, { 'team': team.parent })
                              if(bossParent.length > 0){
                                  if(bossParent.length == 1){
                                      email = bossParent[0].email.replace(/\./g, "||")
                                  }else{
                                      let checkBigBoss2 = false
                                      let arrManager2:Array<any> = [];
                                      for(const i in bossParent){
                                          let mailBoss:any = bossParent[i].email.replace(/\./g, "||")
                                          if(!state.membersByKey[mailBoss].boss){
                                              email = mailBoss.replace(/\./g, "||")
                                              checkBigBoss2 = true
                                          }else{
                                              arrManager2.push({email:state.membersByKey[mailBoss].boss})
                                          }
                                      }
                                      if(!checkBigBoss2){
                                          const checkCountManager2:any = _.filter(arrManager2, { 'email': arrManager2[0].email })
                                          if(arrManager2.length == checkCountManager2.length){
                                              email = arrManager2[0].email.replace(/\./g, "||")
                                          }else{
                                              email = bossParent[0].email.replace(/\./g, "||")
                                          }
                                      }
                                  }
                              }
                          }
                        }
                      }
                    }
                    if(email && state.membersByKey[email]){
                        team.boss_firstname = state.membersByKey[email].firstname
                        team.boss_lastname = state.membersByKey[email].lastname
                        if(state.membersByKey[email].profilepic_small){
                            team.pic = state.membersByKey[email].profilepic_small;
                        }else if (state.membersByKey[email].profilepic_crop){
                            team.pic = state.membersByKey[email].profilepic_crop;
                        }else if (state.membersByKey[email].profilepic){
                            team.pic = state.membersByKey[email].profilepic;
                        }else {
                            team.pic = '';
                        }
                    }else{
                        team.boss_firstname = ''
                        team.boss_lastname = ''
                        team.pic = ''
                    }
                }else{
                    team.boss_firstname = ''
                    team.boss_lastname = ''
                    team.pic = ''
                }
            }
            teams[team.key] = team

          }
          commit('setTeamParentKey',teams)
        }catch(error){
          console.log(error)
        }
      //   firebase.database().ref().child('team').orderByChild('company').equalTo(`${user.company}`).once('value', snapshot => {
      //   const teams:Array<any> = [];
      //   const parent:Array<any> = [];
      //   snapshot.forEach((doc):any => {
      //       const team = doc.val()
      //       team.key = doc.key
      //       team.value = doc.val().name
      //       if(team.sup === undefined){
      //           team.sup = new Array()
      //       }
      //       let teamId = team.key
      //       let arrTeam = state.organizations[teamId];
      //       if(arrTeam){
      //           if (arrTeam.parent) {
      //               if (teamIn[teamId] === undefined) {
      //                   teamIn[teamId] = new Array();
      //               }
      //               teamIn[teamId][teamId] = true;
      //               teamIn[teamId] = globalfunc.getTeamOfParent(arrTeam.parent,teamIn[teamId]);
      //               for (const k in teamIn[teamId]) {
      //                   const userTeam = state.supUserByTeam[k]
      //                   for (const x in userTeam) {
      //                     if(userTeam[x].email){
      //                       let userTeamKey:any = userTeam[x].email.replace(/\./g, "||")
      //                       team.sup = _.concat(team.sup, state.membersByKey[userTeamKey]);
      //                     }
      //                   }
      //               }
      //           }
      //       }else{
      //           const userTeam = state.supUserByTeam[teamId]
      //           for (const x in userTeam) {
      //             if(userTeam[x].email){
      //               let userTeamKey:any = userTeam[x].email.replace(/\./g, "||")
      //               team.sup = _.concat(team.sup, state.membersByKey[userTeamKey]);
      //             }
      //           }
      //       }
      //       team.sup = _.sortBy(team.sup, [function(o:any) { return o.firstname; }])
      //       const boss:any = _.filter(state.bossByKey, { 'team': team.key })
      //       if(boss.length > 0){
      //           let email:any = ""
      //           if(boss.length == 1){
      //               email = boss[0].email.replace(/\./g, "||")
      //           }else{
      //               let checkBigBoss = false
      //               let arrManager:Array<any> = [];
      //               for(const i in boss){
      //                   let mailBoss:any = boss[i].email.replace(/\./g, "||")
      //                   if(!state.membersByKey[mailBoss].boss){
      //                       email = mailBoss.replace(/\./g, "||")
      //                       checkBigBoss = true
      //                   }else{
      //                       arrManager.push({email:state.membersByKey[mailBoss].boss})
      //                   }
      //               }
      //               if(!checkBigBoss){
      //                   const checkCountManager:any = _.filter(arrManager, { 'email': arrManager[0].email })
      //                   if(arrManager.length == checkCountManager.length){
      //                       email = arrManager[0].email.replace(/\./g, "||")
      //                   }else{
      //                       const bossParent:any = _.filter(state.bossByKey, { 'team': team.parent })
      //                       if(bossParent.length > 0){
      //                           email = bossParent[0].email.replace(/\./g, "||")
      //                       }
      //                   }
      //               }
      //           }
      //           if(email && state.membersByKey[email]){
      //               team.boss_firstname = state.membersByKey[email].firstname
      //               team.boss_lastname = state.membersByKey[email].lastname

      //               if(state.membersByKey[email].profilepic_small){
      //                   team.pic = state.membersByKey[email].profilepic_small;
      //               }else if (state.membersByKey[email].profilepic_crop){
      //                   team.pic = state.membersByKey[email].profilepic_crop;
      //               }else if (state.membersByKey[email].profilepic){
      //                   team.pic = state.membersByKey[email].profilepic;
      //               }else {
      //                   team.pic = '';
      //               }
      //           }else{
      //               team.boss_firstname = ''
      //               team.boss_lastname = ''
      //               team.pic = ''
      //           }
                
      //       }else{
      //           if(team.sup.length > 0){
      //               let email:any = ""
      //               if(team.sup.length == 1){
      //                   email = team.sup[0].email.replace(/\./g, "||")
      //               }else {
      //                 let checkInMultipleTeam :any = _.filter(team.sup, { 'team': team.key })
      //                 if(checkInMultipleTeam.length == 1){
      //                     email = checkInMultipleTeam[0].email.replace(/\./g, "||")
      //                 }else{
      //                   let arrManager:Array<any> = [];
      //                   for(const i in team.sup){
      //                       let mailBoss:any = team.sup[i].email.replace(/\./g, "||")
      //                       if(state.membersByKey[mailBoss].boss){
      //                           arrManager.push({email:state.membersByKey[mailBoss].boss})
      //                       }
      //                   }
      //                   if(arrManager[0]){
      //                     const checkCountManager:any = _.filter(arrManager, { 'email': arrManager[0].email })
      //                     if(arrManager.length == checkCountManager.length){
      //                         email = arrManager[0].email.replace(/\./g, "||")
      //                     }else{
      //                         const bossParent:any = _.filter(state.bossByKey, { 'team': team.parent })
      //                         if(bossParent.length > 0){
      //                             if(bossParent.length == 1){
      //                                 email = bossParent[0].email.replace(/\./g, "||")
      //                             }else{
      //                                 let checkBigBoss2 = false
      //                                 let arrManager2:Array<any> = [];
      //                                 for(const i in bossParent){
      //                                     let mailBoss:any = bossParent[i].email.replace(/\./g, "||")
      //                                     if(!state.membersByKey[mailBoss].boss){
      //                                         email = mailBoss.replace(/\./g, "||")
      //                                         checkBigBoss2 = true
      //                                     }else{
      //                                         arrManager2.push({email:state.membersByKey[mailBoss].boss})
      //                                     }
      //                                 }
      //                                 if(!checkBigBoss2){
      //                                     const checkCountManager2:any = _.filter(arrManager2, { 'email': arrManager2[0].email })
      //                                     if(arrManager2.length == checkCountManager2.length){
      //                                         email = arrManager2[0].email.replace(/\./g, "||")
      //                                     }else{
      //                                         email = bossParent[0].email.replace(/\./g, "||")
      //                                     }
      //                                 }
      //                             }
      //                         }
      //                     }
      //                   }
      //                 }
      //               }
      //               if(email && state.membersByKey[email]){
      //                   team.boss_firstname = state.membersByKey[email].firstname
      //                   team.boss_lastname = state.membersByKey[email].lastname
      //                   if(state.membersByKey[email].profilepic_small){
      //                       team.pic = state.membersByKey[email].profilepic_small;
      //                   }else if (state.membersByKey[email].profilepic_crop){
      //                       team.pic = state.membersByKey[email].profilepic_crop;
      //                   }else if (state.membersByKey[email].profilepic){
      //                       team.pic = state.membersByKey[email].profilepic;
      //                   }else {
      //                       team.pic = '';
      //                   }
      //               }else{
      //                   team.boss_firstname = ''
      //                   team.boss_lastname = ''
      //                   team.pic = ''
      //               }
      //           }else{
      //               team.boss_firstname = ''
      //               team.boss_lastname = ''
      //               team.pic = ''
      //           }
      //       }
      //       teams[team.key] = team
      //   });
      //   commit('setTeamParentKey',teams)
      // }).catch(error => {
      //     console.log(error)
      // });
      },

      async getMember({commit,dispatch,state,rootState}:any, user:any){
        
        commit('setLoadingMemberTable',true)
        commit('setLoadingOrgChartView',true)
        commit('setMember',[])
        commit('setDataMembers',[])
        let dateNow = new Date()
        let thisYear = parseInt(format(dateNow, 'YYYY'))
        const dataMembers:Array<any> = []
        const users:Array<any> = [];
        const usersact:Array<any> = [];
        const usersinact:Array<any> = [];
        const usersnew:Array<any> = [];
        const usersinvited:Array<any> = [];
        const dataExport:Array<any> = [];
        const memberKey:Array<any> = [];
        const supUserByTeam:Array<any> = []
        let teamCheck:Array<any> = []
        let archivedSchedule=0
        let userArchivedSchedule:Array<any> =[]
        let orgChartModal:any = {}
        orgChartModal.orgChartArr = new Array()
        orgChartModal.orgChartNoBoss = {}
        orgChartModal.orgChartNoBoss.children = new Array()
        let incomplete:Array<any> = [];
        const team = await getTeamByCompany(user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
        let allUser={}
        // if(state.updateMember==true){
        //   await dispatch('main/removeUser','',{root:true})
        //   allUser = (await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
        // }
        // else if(Object.keys(rootState.main.allUser).length>0){
        //    allUser = rootState.main.allUser
        // }else{
        //   allUser =  await dispatch('main/getuser',true,{root:true})
        // }
        if(state.updateMember==true){
          await dispatch('main/removeUser','',{root:true})
          allUser = await getUserAll(user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
          
        }else{
          allUser = await getUserAll(user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
 
        }
        // //await dispatch('main/getuser',true,{root:true})
        // let allUser =(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
        const company = await getCompany(user.company)
        const allBoss:Array<any> = (await firebase.database().ref(`/boss/${user.company}`).once('value')).val()
        const allArchiveMember = (await firebase.database().ref('users_employee_exit').orderByChild("company").equalTo(user.company).once('value')).val()
        const AllArchiveMembers:Array<any> = []
        const dataManagerMembers:Array<any> = []
        _.forEach(allArchiveMember, (archiveData,key)=> {
          if(allUser && !allUser[key]){
            AllArchiveMembers[archiveData.email] = archiveData
          }
        });
        
        _.forEach(allUser, (arrData,key)=> {
          let u:any= arrData
          if(u){
            if(!u.key)u.key=''
            u.key = key
            if(!u.value)u.value=''
            u.value = u.firstname + " " + u.lastname
            let k_boss = u.boss.replace(/\./g, "||")
            if(k_boss && allUser[k_boss] != undefined){
              if(!u.boss_name)u.boss_name=''
              u.boss_name = allUser[k_boss]["firstname"] + " " + allUser[k_boss]["lastname"]
              if(!u.boss_firstname)u.boss_firstname=''
              u.boss_firstname = allUser[k_boss]["firstname"]
              if(!u.boss_lastname)u.boss_lastname=''
              u.boss_lastname = allUser[k_boss]["lastname"]
              if(!u.boss_shortname)u.boss_shortname=''
              u.boss_shortname = allUser[k_boss]["firstname"] + " " + allUser[k_boss]["lastname"].charAt(0)
              if(!u.boss_team)u.boss_team=''
              u.boss_team = allUser[k_boss]["team"]
              if(!u.boss_team_name)u.boss_team_name=''
              u.boss_team_name = (team[allUser[k_boss]["team"]]!=undefined)?team[allUser[k_boss]["team"]]["name"]:''
              if(!u.boss_pic)u.boss_pic=''
              if(allUser[k_boss]['profilepic_small']){
                u.boss_pic = allUser[k_boss]['profilepic_small'];
              }else if (allUser[k_boss]['profilepic_crop']){
                u.boss_pic = allUser[k_boss]['profilepic_crop'];
              }else if (allUser[k_boss]['profilepic']){
                u.boss_pic = allUser[k_boss]['profilepic'];
              }else {
                u.boss_pic = "";
              }
            }
            if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
            if(u.team) u.team_color = (team[u.team]!=undefined&&team[u.team]["color"])?team[u.team]["color"]:''
            if(u.profilepic_small){
              u.pic = u.profilepic_small;
            }else if (u.profilepic_crop){
              u.pic = u.profilepic_crop;
            }else if (u.profilepic){
              u.pic = u.profilepic;
            }else {
              u.pic = "";
            }
            if(!u.large_pic)u.large_pic=''
            if(u.profilepic) {
              u.large_pic = u.profilepic
            }else if(u.profilepic_crop) {
              u.large_pic = u.profilepic_crop
            }else if(u.profilepic_small){
              u.large_pic = u.profilepic_small
            }else {
              u.large_pic = ""
            }
  
            if(u.tutorial && u.tutorial == 'Y'){
              let dayActive = differenceInCalendarDays(dateNow, u.updated)
              if(dayActive > 30){
                u.status = 'inactive'
                u.to_now = format(u.updated,'MMM D, YYYY')
                u.most_recent_activity = u.status + ' ' + u.updated
              }else{
                u.status = 'active'
                u.to_now = globalfunc.timeSince(u.updated)
                u.most_recent_activity = u.status + ' ' + u.updated
              }
            }else if(u.invited){
              u.status = 'invited'
              u.to_now = globalfunc.timeSince(u.invited)
              u.most_recent_activity = u.status + ' ' + u.invited
            }else{
              u.status = 'new'
            }
  
            if(u.impact_rating){
              u.impact_rating = globalfunc.round(u.impact_rating,1)
            }else{
              u.impact_rating = 0
            }
            u.impact_rating = parseFloat(u.impact_rating.toFixed(1))
            
            if((!u.boss || allUser[k_boss] == undefined) && (u.user_type != 'superleader' && u.user_type != 'superadmin' && u.user_type != 'leadership')){
              let checkDirectReport:any = {};
              checkDirectReport = _.filter(allUser, function(o) {
                  return o['boss']== u.email;
              })
              let _tmp:any = {}
              _tmp.directReport = checkDirectReport.length > 0 ? checkDirectReport.length : 0
              _tmp.firstname = u.firstname
              _tmp.lastname = u.lastname
              _tmp.fullname = u.value
              _tmp.pic = u.pic
              _tmp.id = u.email
              _tmp.teamColor = (u.team_color) ? u.team_color : ''
              _tmp.teamName = (u.team_name) ? u.team_name : ''
              _tmp.status = u.status
              _tmp.impact_rating = u.impact_rating
              _tmp.withOfNode = _tmp.directReport
              orgChartModal.orgChartNoBoss.children.push(_tmp)
  
              let _tmpObjUser:any = {}
              _tmpObjUser.type = 1
              _tmpObjUser.fullname = u.value
              _tmpObjUser.firstname = u.firstname
              _tmpObjUser.lastname = u.lastname
              _tmpObjUser.id = u.email
              _tmpObjUser.value = u.value
              _tmpObjUser.teamName = _tmp.teamName
              _tmpObjUser.status = u.status
              _tmpObjUser.impact_rating = u.impact_rating
              _tmpObjUser.refId = new Array()
              _tmpObjUser.refId.push(u.email)
              orgChartModal.orgChartArr.push(_tmpObjUser)
            }
  
            // if(company.medal && u.medal){
            //   _.forEach(u.medal, (value,key)=> {
            //     u.medal[key] = company.medal[key]
            //   });
            // }
            if(u.status == 'active'){
              usersact.push(u)
            }else if(u.status == 'inactive') {
              usersinact.push(u)
            }else if(u.status == 'new'){
              usersnew.push(u)
            }else if(u.status == 'invited'){
              usersinvited.push(u)
            }
            if(supUserByTeam[u.team] === undefined){
              supUserByTeam[u.team] = new Array()
            }
            if(!u.boss && (u.user_type == 'superleader' || u.user_type == 'superadmin' || u.user_type == 'leadership')){
              u.inorder = -999
              incomplete.push(u)
              let checkDirectReport:any= {};
              if(!u.email)u.email=''
              checkDirectReport = _.filter(allUser, function(o) {
                  return o['boss']== u.email;
              })
       
              orgChartModal.orgChart = {}
              orgChartModal.orgChart.directReport = checkDirectReport.length > 0 ? checkDirectReport.length : 0
              orgChartModal.orgChart.firstname = u.firstname
              orgChartModal.orgChart.lastname = u.lastname
              orgChartModal.orgChart.fullname = u.value
              orgChartModal.orgChart.pic = u.pic
              orgChartModal.orgChart.id = u.email
              orgChartModal.orgChart.teamColor = (u.team_color) ? u.team_color : ''
              orgChartModal.orgChart.teamName = (u.team_name) ? u.team_name : ''
              orgChartModal.orgChart.status = u.status
              orgChartModal.orgChart.impact_rating = u.impact_rating
              orgChartModal.orgChart.withOfNode = orgChartModal.orgChart.directReport
  
              if(teamCheck[u.team] == undefined){
                teamCheck[u.team] = new Array()
                teamCheck[u.team] = true
                let _tmpObj:any = {}
                _tmpObj.type = 0
                _tmpObj.fullname = orgChartModal.orgChart.teamName
                _tmpObj.id = u.email
                _tmpObj.value = orgChartModal.orgChart.teamName
                _tmpObj.teamName = ''
                _tmpObj.status = u.status
                _tmpObj.impact_rating = u.impact_rating
                _tmpObj.refId = new Array()
                _tmpObj.refId.push(u.email)
                _tmpObj.teamMembers = new Array()
                let arrTeamMember:any ={}
                if(!u.team)u.team=''
                arrTeamMember = _.filter(allUser,function(o) {
                    return o['team']== u.team;
                })
               
                if(arrTeamMember.length > 0){
                  _.forEach(arrTeamMember, (item_arrTeamMember,key_arrTeamMember)=> {
                    _tmpObj.teamMembers.push(item_arrTeamMember.email)
                  });
                }
                orgChartModal.orgChartArr.push(_tmpObj)
              }
              let _tmpObjUser:any = {}
              _tmpObjUser.type = 1
              _tmpObjUser.fullname = u.value
              _tmpObjUser.firstname = u.firstname
              _tmpObjUser.lastname = u.lastname
              _tmpObjUser.id = u.email
              _tmpObjUser.value = u.value
              _tmpObjUser.teamName = orgChartModal.orgChart.teamName
              _tmpObjUser.status = u.status
              _tmpObjUser.impact_rating = u.impact_rating
              _tmpObjUser.refId = new Array()
              _tmpObjUser.refId.push(u.email)
              orgChartModal.orgChartArr.push(_tmpObjUser)
              
            }else if(!u.boss || !u.team || (u.boss && allUser[k_boss] == undefined) || (u.team && team[u.team] == undefined)){
              u.inorder = 0
              incomplete.push(u)
            }
            if(u.joined_tooltips === undefined){
              u.joined_tooltips = new Array()
            }
            if(u.workdate){
              u.joined = format(u.workdate,'MMMM D, YYYY')
              let arrJoined:Array<any> = [];
              arrJoined['year'] = differenceInCalendarYears(dateNow, u.workdate)
              let month = differenceInCalendarMonths(dateNow, setYear(u.workdate,thisYear))
              if(month < 0){
                arrJoined['month'] = month + 12
                arrJoined['year'] = (arrJoined['year'] > 0) ? arrJoined['year'] - 1 : 0
              }else{
                arrJoined['month'] = month
              }
              let day = parseInt(format(dateNow,'DD')) - parseInt(format(u.workdate,'DD'))
              if(day < 0){
                arrJoined['day'] = day + parseInt(format(lastDayOfMonth(addMonths(dateNow, -1)),'DD'));
                if(arrJoined['month'] > 0){
                  arrJoined['month'] = arrJoined['month'] - 1
                }else{
                  arrJoined['month'] = 12
                  arrJoined['year'] = (arrJoined['year'] > 0) ? arrJoined['year'] - 1 : 0
                }
              }else{
                arrJoined['day'] = day
              }
              u.joined_tooltips.push(arrJoined)
            }
            //check no team and boss in database
            if(u.team && !team[u.team]){
              u.teamArchive = "Please Assign Team"
            }
            if(u.boss && allUser[k_boss] == undefined){
              u.bossArchive = "Please Assign Manager"
            }
            //end check no team and boss in database
            if(u.boss && AllArchiveMembers[u.boss]){
              if(dataManagerMembers[u.boss] === undefined){
                dataManagerMembers[u.boss] = new Array()
              }
              dataManagerMembers[u.boss].push(u)
            }
            const dataEx = {
              'First Name': u.firstname,
              'Last Name': u.lastname,
              'Email Address': u.email,
              'Team Name': (u.teamArchive)?u.teamArchive:u.team_name,
              'Direct Manager (E-mail)': (u.bossArchive)?u.bossArchive:u.boss,
              'Coins': u.coin,
              'Gems': u.gem,
              'Status': u.status,
              'Last Visit': (u.tutorial == 'Y') ? u.updated : '',
              'Create Date': u.createdatetime,
              'Modified Date': u.modifydatetime
            }
            dataExport.push(dataEx)
            memberKey[u.key] = u
            supUserByTeam[u.team].push(u)
            
            if(u.archive_date){
              archivedSchedule++
              if(!u.archiveddate)u.archiveddate=''
              u.archiveddate =format(new Date(u.archive_date),"MMM D, YYYY h:mm A")
              u.archiveSchedule=true
              u.archive_type=u.archive_type=='resigned'?'Resigned':u.archive_type=='terminated'?'Terminated':'Other'
              userArchivedSchedule.push(u)
            }
            users.push(u)
          }
        });
        if(orgChartModal.orgChart && orgChartModal.orgChart.id){
          let getChild:Array<any> = [];
          getChild = _.filter(users, { 'boss': orgChartModal.orgChart.id })
          if(getChild.length > 0){
            orgChartModal.orgChart.children = new Array()
            _.forEach(getChild, (item,key)=> {
              if(memberKey[item.email.replace(/\./g, "||")] != undefined){
                let _tmp:any = {}
                let _tmpObj:any = {}
                let checkDirectReport:Array<any> = [];
                checkDirectReport = _.filter(users, { 'boss': item.email })
                _tmp.directReport = checkDirectReport.length > 0 ? checkDirectReport.length : 0
                _tmp.firstname = item.firstname
                _tmp.lastname = item.lastname
                _tmp.fullname = item.value
                _tmp.pic = item.pic
                _tmp.id = item.email
                _tmp.teamColor = (item.team_color) ? item.team_color : ''
                _tmp.teamName = (item.team_name) ? item.team_name : ''
                _tmp.status = item.status
                _tmp.impact_rating = item.impact_rating
                _tmp.withOfNode = _tmp.directReport
                orgChartModal.orgChart.children.push(_tmp)

                let _tmpObjUser:any = {}
                _tmpObjUser.type = 1
                _tmpObjUser.fullname = item.value
                _tmpObjUser.firstname = item.firstname
                _tmpObjUser.lastname = item.lastname
                _tmpObjUser.id = item.email
                _tmpObjUser.value = item.value
                _tmpObjUser.teamName = item.team_name
                _tmpObjUser.status = item.status
                _tmpObjUser.impact_rating = item.impact_rating
                _tmpObjUser.refId = new Array()
                _tmpObjUser.refId.push(orgChartModal.orgChart.id)
                _tmpObjUser.refId.push(item.email)
                orgChartModal.orgChartArr.push(_tmpObjUser)

                if(teamCheck[item.team] == undefined){
                  teamCheck[item.team] = new Array()
                  teamCheck[item.team] = true
                  _tmpObj.type = 0
                  _tmpObj.fullname = _tmp.teamName
                  _tmpObj.id = item.email
                  _tmpObj.value = _tmp.teamName
                  _tmpObj.teamName = ''
                  _tmpObj.status = _tmp.status
                  _tmpObj.impact_rating = _tmp.impact_rating
                  _tmpObj.refId = new Array()
                  _tmpObj.refId.push(orgChartModal.orgChart.id)
                  _tmpObj.refId.push(item.email)
                  _tmpObj.teamMembers = new Array()
                  let arrTeamMember:Array<any> = [];
                  arrTeamMember = _.filter(users, { 'team': item.team })
                  if(arrTeamMember.length > 0){
                    _.forEach(arrTeamMember, (item_arrTeamMember,key_arrTeamMember)=> {
                      _tmpObj.teamMembers.push(item_arrTeamMember.email)
                    });
                  }
                  orgChartModal.orgChartArr.push(_tmpObj)
                }
                let _tmpChildren:Array<any> = [];
                _tmpChildren = _.filter(users, { 'boss': item.email })
                if(_tmpChildren.length > 0){
                  var promise1 = new Promise(function(resolve, reject) {
                    const children = dispatch('getChildren', {children: _tmpChildren,allUser: users, memberKey: memberKey, refId: _tmpObj.refId, teamCheck: teamCheck, orgChartModal: orgChartModal});
                    resolve(children);
                  });
                  Promise.all([promise1]).then((values)=> {
                    const data1:any = values[0]
                    orgChartModal.orgChart.children[key]['children'] = new Array()
                    orgChartModal.orgChart.children[key]['children'] = data1
                });
                }else{
                  orgChartModal.orgChart.children[key]['children'] = {}
                }
              }
            });
          }
        }
        let _users:Array<any> = [];
        _users = _.sortBy(users, [function(o:any) { return o.workdate; }])
        let orderJoin = 1
        _.forEach(_users, (item,key)=> {
          if(item.workdate){
            _users[key].order_join = orderJoin
            orderJoin++
          }
        });
        let checkOrder:Array<any> = [];
        if(incomplete.length > 0){
          checkOrder = _.filter(incomplete, { 'inorder': -999 } as object)
          if(checkOrder.length > 1 || incomplete.length > 1 || (incomplete.length == 1 && checkOrder.length == 0)){
            _users = _.sortBy(_users, [function(o:any) { return o.inorder; }, function(o:any) { return o.firstname; }])
          }else{
            _users = _.sortBy(_users, [function(o:any) { return o.firstname; }])
          }
        }else{
          _users = _.sortBy(_users, [function(o:any) { return o.firstname; }])
        }
        orgChartModal.orgChartArr = _.sortBy(orgChartModal.orgChartArr, ["type", "fullname"]);
        commit('setOrgChartView',orgChartModal)
        commit('setAllArchiveData',AllArchiveMembers)
        commit('setManagerMembers',dataManagerMembers)
        commit('setResults',_users)
        commit('setMember', _users.slice(0, state.size_page))
        commit('setMemberKey', memberKey)
        commit('setBossKey', allBoss)
        commit('setTeamKey', team)
        commit('setsupUserByTeam', supUserByTeam)
        commit('setIncomplete',incomplete)
        commit('setArchivedSchedule',archivedSchedule)
        commit('setUserArchivedSchedule',userArchivedSchedule)
        dataMembers['membersall'] = _users
        dataMembers['membersact'] = usersact
        dataMembers['membersinact'] = usersinact
        dataMembers['membersnew'] = usersnew
        dataMembers['membersinvited'] = usersinvited
        commit('setDataMembers',dataMembers)
        
        commit('setDataExport', dataExport)
        commit('setLoadingMemberTable',false)
        commit('setLoadingOrgChartView',false)
        if(state.inputSearch){
          dispatch('searchMembers',state.inputSearch)
        }else{
          if(state.page !== 1){
            dispatch('currentChange',state.page)
          }
        }
      },
      async getChildren({ dispatch, state }: any, obj:any){
        const arrData: Array<any> = [];
        const allUser = obj.allUser
        const children = obj.children
        const memberKey = obj.memberKey
        const refId = obj.refId
        let teamCheck = obj.teamCheck
        let orgChartModal = obj.orgChartModal
        if(children.length > 0){
          _.forEach(children, (item,key)=> {
            if(memberKey[item.email.replace(/\./g, "||")] != undefined){
              let _tmp:any = {}
              let _tmpObj:any = {}
              let checkDirectReport:Array<any> = [];
              checkDirectReport = _.filter(allUser, { 'boss': item.email })
              _tmp.directReport = checkDirectReport.length > 0 ? checkDirectReport.length : 0
              _tmp.firstname = item.firstname
              _tmp.lastname = item.lastname
              _tmp.fullname = item.value
              _tmp.pic = item.pic
              _tmp.id = item.email
              _tmp.teamColor = (item.team_color) ? item.team_color : ''
              _tmp.teamName = (item.team_name) ? item.team_name : ''
              _tmp.status = item.status
              _tmp.impact_rating = item.impact_rating
              _tmp.withOfNode = _tmp.directReport > 0 ? _tmp.directReport : 1
              arrData.push(_tmp)

              let _tmpObjUser:any = {}
              _tmpObjUser.type = 1
              _tmpObjUser.fullname = item.value
              _tmpObjUser.firstname = item.firstname
              _tmpObjUser.lastname = item.lastname
              _tmpObjUser.id = item.email
              _tmpObjUser.value = item.value
              _tmpObjUser.teamName = item.team_name
              _tmpObjUser.status = item.status
              _tmpObjUser.impact_rating = item.impact_rating
              _tmpObjUser.refId = new Array()
              _.forEach(refId, (item,key)=> {
                _tmpObjUser.refId.push(item)
              });
              orgChartModal.orgChartArr.push(_tmpObjUser)

              if(refId){
                if(teamCheck[item.team] == undefined){
                  teamCheck[item.team] = new Array()
                  teamCheck[item.team] = true
                  _tmpObj.type = 0
                  _tmpObj.fullname = _tmp.teamName
                  _tmpObj.id = _tmp.id
                  _tmpObj.value = _tmp.teamName
                  _tmpObj.teamName = ''
                  _tmpObj.status = _tmp.status
                  _tmpObj.impact_rating = _tmp.impact_rating
                  _tmpObj.refId = new Array()
                  _.forEach(refId, (item,key)=> {
                    _tmpObj.refId.push(item)
                  });
                  _tmpObj.refId.push(_tmp.id)
                  _tmpObj.teamMembers = new Array()
                  let arrTeamMember:Array<any> = [];
                  arrTeamMember = _.filter(allUser, { 'team': item.team })
                  if(arrTeamMember.length > 0){
                    _.forEach(arrTeamMember, (item_arrTeamMember,key_arrTeamMember)=> {
                      _tmpObj.teamMembers.push(item_arrTeamMember.email)
                    });
                  }
                  orgChartModal.orgChartArr.push(_tmpObj)
                }
              }
              let _tmpChildren:Array<any> = [];
              _tmpChildren = _.filter(allUser, { 'boss': item.email })
              if(_tmpChildren.length > 0){
                var promise1 = new Promise(function(resolve, reject) {
                  const children = dispatch('getChildren', {children: _tmpChildren,allUser: allUser, memberKey: memberKey, refId: _tmpObj.refId, teamCheck: teamCheck, orgChartModal: orgChartModal});
                  resolve(children);
                });
                Promise.all([promise1]).then((values)=> {
                  const data1:any = values[0]
                  arrData[key]['children'] = new Array()
                  arrData[key]['children'] = data1
                });
              }else{
                arrData[key]['children'] = {}
              }
            }
          });
        }
        return arrData
      },
      async getTeamAll({commit,dispatch,state,rootState}:any, user:any){
        let allUser:any={}
        if(rootState.dashboard.memberAndTeam.users){
           allUser =rootState.dashboard.memberAndTeam.users
        }else{
          // await dispatch('main/getuser',true,{root:true})
          allUser = (await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
        }
        const userTeam= _.groupBy(allUser, function (b) {
          return b.team;
        });
        // let empty:Array<any>=[]
        try{
          const teamData:Array<any> = [];
          const team = await getTeamByCompany(user.company)
          for(const key in team){
            const u = team[key]
            u.key = key
            u.value = team[key].name
            teamData.push(u)
          }
          commit('setTeamall', _.sortBy(teamData, [function(o:any) { return o.name; }]))
        }catch(error){
          console.log(error)
        }
        // firebase.database().ref('team').orderByChild("company").equalTo(`${user.company}`).once('value', snapshot => {
        //   const teamData:Array<any> = [];
        //   snapshot.forEach((arrData):any => {
        //     const u = arrData.val()
        //     u.key = arrData.key
        //     u.value = arrData.val().name
        //     // if(arrData.key){
        //     //   if(!userTeam[arrData.key]){
        //     //     empty.push(u)
        //     //   }
        //     // }
           
        //     teamData.push(u)
            
        //   });
        //   // commit('setEmptyMember', empty)
        //   commit('setTeamall', _.sortBy(teamData, [function(o:any) { return o.name; }]))
        // }).catch(error => {
        //   console.log(error)
        // });
      },
      currentChange({commit,state}:any,page:any){
        var size = state.size_page
        var start_row = (page-1) * size
        var end_row = ((page-1) * size)+size
        let member: Array<any> = [];
        if(state.type == 'active'){
          member.push(state.datamembers['membersact'])
        }else if(state.type == 'inactive'){
          member.push(state.datamembers['membersinact'])
        }else if(state.type == 'new'){
          member.push(state.datamembers['membersnew'])
        }else if(state.type == 'invited'){
          member.push(state.datamembers['membersinvited'])
        }else{
          member.push(state.datamembers['membersall'])
        }
        if (state.inputSearch.length > 2){
          if (member.length > 0){
            var re = new RegExp(state.inputSearch, 'gi')
            var response = _.filter(member[0], (item): any => {
              if (item.firstname.match(re)) {
                return true
              } else if (item.lastname != undefined && item.lastname.match(re)) {
                return true
              } else if (item.value != undefined && (item.value.match(re))) {
                return true
              } else if (item.email != undefined && item.email.match(re)) {
                return true
              } else if (item.team_name != undefined && item.team_name.match(re)) {
                return true
              } else if (item.boss_firstname != undefined && item.boss_firstname.match(re)) {
                return true
              } else if (item.boss_lastname != undefined && item.boss_lastname.match(re)) {
                return true
              } else if (item.boss_name != undefined && item.boss_name.match(re)) {
                return true
              }
            });
            member[0] = response
          }
        }
        var field = state.sortfield
        let checkOrder:Array<any> = [];
        let _users:Array<any> = [];
        if(state.incomplete.length > 0){
          checkOrder = _.filter(state.incomplete, { 'inorder': -999 })
          if(checkOrder.length > 1 || state.incomplete.length > 1 || (state.incomplete.length == 1 && checkOrder.length == 0)){
            _users = _.orderBy(member[0], ["inorder",field], ["asc",state.sortorder]);
          }else{
            _users = _.orderBy(member[0], [field], [state.sortorder]);
          }
        }else{
          _users = _.orderBy(member[0], [field], [state.sortorder]);
        }
        // var _users = _.orderBy(member[0], ["inorder",field], ["asc",state.sortorder]);
        commit('setPage',page)
        commit('setMember', _users.slice(start_row,end_row))
      },
      archiveCurrentChange({commit,state}:any,page:any){
        var size = state.size_page
        var start_row = (page-1) * size
        var end_row = ((page-1) * size)+size
        let member: Array<any> = [];
        member.push(state.membersArchiveAll)
        if (state.inputSearchArchive.length > 2){
          if (member.length > 0){
            var re = new RegExp(state.inputSearchArchive, 'gi')
            var response = _.filter(member[0], (item): any => {
              if (item.firstname.match(re)) {
                return true
              } else if (item.lastname != undefined && item.lastname.match(re)) {
                return true
              } else if (item.value != undefined && (item.value.match(re))) {
                return true
              } else if (item.email != undefined && item.email.match(re)) {
                return true
              } else if (item.team_name != undefined && item.team_name.match(re)) {
                return true
              } else if (item.boss_firstname != undefined && item.boss_firstname.match(re)) {
                return true
              } else if (item.boss_lastname != undefined && item.boss_lastname.match(re)) {
                return true
              } else if (item.boss_name != undefined && item.boss_name.match(re)) {
                return true
              }
            });
            member[0] = response
          }
        }
        
        var field = state.sortfieldarchive
        var _users = _.orderBy(member[0], [field], [state.sortorderarchive]);
        commit('setPageArchive',page)
        commit('setMemberArchive', _users.slice(start_row,end_row))
      },
      async createMember({commit,rootState,dispatch,state}:any,obj:any){
        let form = obj.form
        let invite = obj.invite
        commit('setLoadingMemberTable',true)
        commit('setMember',[])
        let team:any = ""
        const teamMaster = await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
        const allUser =  await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        let teamFind = _.findKey(teamMaster, item => {
          return item.name.toLowerCase() === form.dispteam.toLowerCase();
        });

        let bossKey = form.boss.replace(/\./g, "||")
        let parentId = (allUser && allUser[bossKey] && allUser[bossKey].team)?allUser[bossKey].team : ""
        if(teamFind && teamFind !== undefined){
          team = teamFind
          if(state.teamByKey[team] && parentId && team !== parentId){
          // if(state.teamByKey[team] && state.teamByKey[team].parent == '' && parentId && team !== parentId){
            firebase.database().ref(`team/${team}`).update({
              parent:parentId,
              updated:format(new Date(), 'YYYY-MM-DD HH:mm')
            }).then(()=>{
              firebase.database().ref(`/genorganize`).push({
                  company:rootState.authen.user.company
              });
            });
          }
        }else{
          let internal_id = "t"+globalfunc.generateRandomNumber()
          team = firebase.database().ref('team').push().key;
          firebase.database().ref(`team/${team}`).update({
            name:form.dispteam,
            parent:parentId,
            company:rootState.authen.user.company,
            internal_id:internal_id,
            updated:format(new Date(), 'YYYY-MM-DD HH:mm')
          }).then(()=>{
            firebase.database().ref(`/genorganize`).push({
                company:rootState.authen.user.company
            });
            /*save logs*/
            dispatch('authen/addLogs', {
              company: rootState.authen.user.company,
                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                id: team,
                table: 'team',
                status: 'add',
                user: rootState.authen.user.email
            }, {root:true})
          });
        }
        
        let ctemail = form.email.toLowerCase()
        ctemail = ctemail.replace(/ /g, "")
        const newId = ctemail.replace(/\./g, "||")
        const split_time_zone = form.time_zone.split(':')
        if(Number(split_time_zone[1]) == 15){
          form.time_zone= split_time_zone[0]+'.25'
        }else if(Number(split_time_zone[1]) == 30){
          form.time_zone = split_time_zone[0]+'.5'
        }else if(Number(split_time_zone[1]) == 45){
          form.time_zone = split_time_zone[0]+'.75'
        }else{
          form.time_zone=Number(form.time_zone.replace(':','.'))
        }
        //form.time_zone=Number(form.time_zone.replace(':','.'))
        let time_zone=(+form.time_zone == Math.floor(+form.time_zone))?parseInt(form.time_zone):parseFloat(form.time_zone)
        const userComp = rootState.authen.user.company
        const userBoss = form.boss
        
        firebase.database().ref(`/users`).child(newId).set({
            firstname:form.firstname.trim(),
            lastname:form.lastname.trim(),
            nickname:form.nickname ? form.nickname.trim() : '',
            email:ctemail,
            company:userComp,
            team,
            boss:userBoss,
            language:form.language,
            user_type:form.user_type,
            gem:0,
            coin:0,
            powerup:{
              fivecoins:"14",
              threecoins:"7",
            },
            profilepic:"",
            address:"",
            mobile:"",
            phone:"",
            timezone:time_zone,
            country:form.country.toLowerCase().trim()==="thailand"?'TH':form.country,
            updated:format(new Date(), 'YYYY-MM-DD HH:mm'),
            createdatetime:format(new Date(), 'YYYY-MM-DD HH:mm'),
            modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
        }).then(()=>{
          if(userBoss){
            firebase.database().ref(`/genboss`).push({
              company:userComp
            })
          }
        }).then(()=>{
          if(invite == true){
            firebase.database().ref(`/user_invite`).push({
              email:ctemail
            }).then(()=>{
              let Id = ctemail.replace(/\./g, "||")
              firebase.database().ref(`/users/${Id}`).update({
                invited:format(new Date(), 'YYYY-MM-DD HH:mm:ss')
              })
            })
          }
        }).then(()=>{
          // dispatch('sendQuestionNew',{
          //     newId,
          //     email:ctemail,
          //     company:userComp,
          //     team,
          //   });
          }).then(function() {
            if(!teamFind || teamFind == undefined || teamFind == ''){
              dispatch('getTeamAll',rootState.authen.user)
            }
            /*save logs*/
            dispatch('authen/addLogs', {
              company: userComp,
              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
              id: newId,
              table: 'users',
              status: 'add',
              user: rootState.authen.user.email
            }, {root:true}).then(function() {
              commit('setPage',1)
              // setTimeout(() => {
              //   let data={...rootState.authen.user,getMember:true}
              //   dispatch('getMember',data)
              // }, 3000)
              commit('setUpdateMember',true)
              dispatch('getMember',rootState.authen.user)
            });
          });
       
        },
        async sendQuestionNew({commit,rootState,dispatch}:any, value:any){
          const company = await getCompany(value.company)//(await firebase.database().ref(`company/${value.company}`).once('value')).val()
          const category = (await firebase.database().ref('category').orderByChild("status").equalTo("Y").once('value')).val()
          const questions = (await firebase.database().ref('questions').once('value')).val()
          const timeZone = (company.timezone && company.timezone !== undefined) ? Number(company.timezone) : 7;
          const day = format(new Date().setUTCHours(timeZone), 'dddd');
          if(day !== 'Saturday' && day !== 'Sunday'){
              const datenow = format(new Date(), 'YYYY-MM-DD');
              firebase.firestore().collection('log_company').where('date', '==', datenow).where('type', '==', 'users_questions').get()
                .then(function (querySnapshot) {
                    if (querySnapshot.empty) {
                     // console.log('log_company no matching documents.');
                      /*save logs*/
                      dispatch('authen/addLogs', {
                        company: value.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        id: value.newId,
                        table: 'users',
                        status: 'add',
                        user: rootState.authen.user.email
                      }, {root:true}).then(function() {
                        commit('setPage',1)
                        // setTimeout(() => {
                        //   let data={...rootState.authen.user,getMember:true}
                        //   dispatch('getMember',data)
                        // }, 3000)
                        commit('setUpdateMember',true)
                        dispatch('getMember',rootState.authen.user)
                      });
                    }else {
                      let company_list = [];
                      querySnapshot.forEach(function (doc) {
                        const data = doc.data();
                        company_list = data.company_list;
                      });
                      const company_ck = _.indexOf(company_list, value.company);
                      if(company_ck > -1){
                        const get_questions_arr = [`-Kgs61AHOnpJ3rfyQr6t`, `-Lww4xIIHQ5hmxEhR2nE`];
                        const optType = {'Multiple Choice': 0, 'Text Area Field': 2, 'Scale': 5};
                        let i = 0;
                        for (const questid in get_questions_arr) {
                            const quest = get_questions_arr[questid];
                            const dataArr = {};
                            dataArr[`calculate`] = '1';
                            dataArr[`quest_id`] = quest;
                            dataArr[`genus`] = questions[quest][`genus`];
                            dataArr[`quest_name`] = questions[quest][`question`];
                            dataArr[`quest_name_en`] = questions[quest][`question_en`];
                            dataArr[`type`] = questions[quest][`type`];
                            if (dataArr[`type`] === 'Multiple Choice') {
                                dataArr[`m_choice`] = (questions[quest][`m_choice`][`th`] !== undefined) ? questions[quest][`m_choice`][`th`].join(',') : '';
                                dataArr[`m_choice_en`] = (questions[quest][`m_choice`][`en`] !== undefined) ? questions[quest][`m_choice`][`en`].join(',') : '';
                                dataArr[`m_choice_points`] = (questions[quest][`m_choice`][`points`] !== undefined) ? questions[quest][`m_choice`][`points`].join(',') : '';
                                dataArr[`pages`] = (questions[quest][`m_choice`][`th`].length > 2) ? optType[questions[quest][`type`]] : 1;
                            } else {
                                dataArr[`less_txt`] = (questions[quest][`less_txt`] !== undefined) ? questions[quest][`less_txt`] : '';
                                dataArr[`less_txt_en`] = (questions[quest][`less_txt_en`] !== undefined) ? questions[quest][`less_txt_en`] : '';
                                dataArr[`max_txt_en`] = (questions[quest][`max_txt_en`] !== undefined) ? questions[quest][`max_txt_en`] : '';
                                dataArr[`max_txt`] = (questions[quest][`max_txt`] !== undefined) ? questions[quest][`max_txt`] : '';
                                dataArr[`points`] = (questions[quest][`points`] !== undefined) ? questions[quest][`points`] * 1 : '';
                                dataArr[`pages`] = optType[questions[quest][`type`]];
                            }
                            dataArr[`category`] = category[questions[quest][`category`]][`category`];
                            dataArr[`dark_color`] = category[questions[quest][`category`]][`dark_color`];
                            dataArr[`light_color`] = category[questions[quest][`category`]][`light_color`];
                            dataArr[`image`] = category[questions[quest][`category`]][`filepath`];
                            dataArr[`users`] = value.email;
                            dataArr[`date`] = datenow;
                            dataArr[`status`] = 'open';
                            dataArr[`updated`] = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
                            dataArr[`company`] = value.company;
                            dataArr[`team`] = value.team;
                            dataArr[`parent`] = '';
                            dataArr[`priority`] = (quest === '-Kgs61AHOnpJ3rfyQr6t') ? 3 : 4;

                            firebase.firestore().collection('users_questions').add(dataArr);

                            if(i === 1) {
                              //console.log(rootState.authen.user.email);
                              /*save logs*/
                              dispatch('authen/addLogs', {
                                company: value.company,
                                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                                id: value.newId,
                                table: 'users',
                                status: 'add',
                                user: rootState.authen.user.email
                              }, {root:true}).then(function() {
                                commit('setPage',1)
                                // setTimeout(() => {
                                //   let data={...rootState.authen.user,getMember:true}
                                //   dispatch('getMember',data)
                                // }, 3000)
                                commit('setUpdateMember',true)
                                dispatch('getMember',rootState.authen.user)
                              });
                            }
                            i++;
                          }
                        }else {
                          /*save logs*/
                          dispatch('authen/addLogs', {
                            company: value.company,
                            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                            id: value.newId,
                            table: 'users',
                            status: 'add',
                            user: rootState.authen.user.email
                          }, {root:true}).then(function() {
                            commit('setPage',1)
                            // setTimeout(() => {
                            //   let data={...rootState.authen.user,getMember:true}
                            //   dispatch('getMember',data)
                            // }, 3000)
                            commit('setUpdateMember',true)
                            dispatch('getMember',rootState.authen.user)
                          });
                        }
                    }
              });
          }else {
            /*save logs*/
            dispatch('authen/addLogs', {
              company: value.company,
              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
              id: value.newId,
              table: 'users',
              status: 'add',
              user: rootState.authen.user.email
            }, {root:true}).then(function() {
              commit('setPage',1)
              // setTimeout(() => {
              //   let data={...rootState.authen.user,getMember:true}
              //   dispatch('getMember',data)
              // }, 3000)
              commit('setUpdateMember',true)
              dispatch('getMember',rootState.authen.user)
            });
          }
        },
        async updateMember({commit,rootState,dispatch,state}:any,value_form:any){
          commit('membermanager/setLoadingManagersTable',true,{root:true})
          commit('setLoadingMemberTable',true)
          commit('setMember',[])
          const value=_.cloneDeep(value_form)
          const boss = value.form.boss
          const userComp = rootState.authen.user.company
          let team:any = ""
          const teamMaster = await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
          const allUser = await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
          let teamFind = _.findKey(teamMaster, item => {
            return item.name.toLowerCase() === value.form.dispteam.toLowerCase();
          });
          
          let bossKey = boss.replace(/\./g, "||")
          let parentId = (allUser[bossKey] && allUser[bossKey].team)?allUser[bossKey].team : ""
          if(teamFind && teamFind !== undefined){
            team = teamFind
            if(state.teamByKey[team] && parentId && team !== parentId){
            // if(state.teamByKey[team] && state.teamByKey[team].parent == '' && parentId && team !== parentId){
              firebase.database().ref(`team/${team}`).update({
                parent:parentId,
                updated:format(new Date(), 'YYYY-MM-DD HH:mm')
              }).then(()=>{
                firebase.database().ref(`/genorganize`).push({
                    company:rootState.authen.user.company
                });
              });
            }
          }else{
            let internal_id = "t"+globalfunc.generateRandomNumber()
            team = firebase.database().ref('team').push().key;
            firebase.database().ref(`team/${team}`).update({
              name:value.form.dispteam,
              parent:parentId,
              company:rootState.authen.user.company,
              internal_id: internal_id,
              updated:format(new Date(), 'YYYY-MM-DD HH:mm')
            }).then(()=>{
              firebase.database().ref(`/genorganize`).push({
                  company:rootState.authen.user.company
              });
              /*save logs*/
              dispatch('authen/addLogs', {
                company: rootState.authen.user.company,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: team,
                  table: 'team',
                  status: 'add',
                  user: rootState.authen.user.email
              }, {root:true})
            });
          }
          const split_time_zone = value.form.time_zone.split(':')
          if(Number(split_time_zone[1]) == 15){
            value.form.time_zone = split_time_zone[0]+'.25'
          }else if(Number(split_time_zone[1]) == 30){
            value.form.time_zone = split_time_zone[0]+'.5'
          }else if(Number(split_time_zone[1]) == 45){
            value.form.time_zone = split_time_zone[0]+'.75'
          }else{
            value.form.time_zone=Number(value.form.time_zone.replace(':','.'))
          }
          //value.form.time_zone=Number(value.form.time_zone.replace(':','.'))
          //console.log('value.form.time_zone',value.form.time_zone)
          let time_zone=(+value.form.time_zone == Math.floor(+value.form.time_zone))?parseInt(value.form.time_zone):parseFloat(value.form.time_zone)
          //console.log('time_zone',time_zone)
          const updatePayload:any = {
              firstname:value.form.firstname.trim(),
              lastname:value.form.lastname.trim(),
              nickname:value.form.nickname ? value.form.nickname.trim() : '',
              team:team,
              boss:boss,
              language:value.form.language,
              user_type:value.form.user_type,
              timezone:time_zone,
              country:value.form.country.toLowerCase().trim()==="thailand"?'TH':value.form.country,
              // updated:format(new Date(), 'YYYY-MM-DD HH:mm'),
              modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
          }
          if (value.form.birthday_month && value.form.birthday_day) {
            updatePayload.birthday = `0000-${String(value.form.birthday_month).padStart(2,'0')}-${String(value.form.birthday_day).padStart(2,'0')}`
          } else {
            updatePayload.birthday = null
          }
          updatePayload.workdate = value.form.workdate || null
          firebase.database().ref(`/users/${value.id}`).update(updatePayload).then(()=>{

            // if(tmp_boss != boss){
              firebase.database().ref(`/genboss`).push({
                company:userComp
              })
            // }
          //dispatch('main/removeUser',true,{root:true})
        }).then(()=>{
            /*save logs*/
            dispatch('authen/addLogs', {
              company: userComp,
              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
              id: value.id,
              table: 'users',
              status: 'edit',
              user: rootState.authen.user.email
            }, {root:true}).then(function() {
              if(!teamFind || teamFind == undefined || teamFind == ''){
                dispatch('getTeamAll',rootState.authen.user)
              }
              // commit('setPage',1)
              // setTimeout(() => {
              //   let data={...rootState.authen.user,getMember:true}
              //   dispatch('getMember',data)
              // }, 3000)
              commit('setUpdateMember',true)
              dispatch('getMember',rootState.authen.user)
            });
          });
          
        },
        searchMembers({commit,state}:any,value:string){
          let field = state.sortfield
          let order = state.sortorder
          commit('setPage',1)
          const member: Array<any> = [];
          if(state.type == 'active'){
            member.push(state.datamembers['membersact'])
          }else if(state.type == 'inactive'){
            member.push(state.datamembers['membersinact'])
          }else if(state.type == 'new'){
            member.push(state.datamembers['membersnew'])
          }else if(state.type == 'invited'){
            member.push(state.datamembers['membersinvited'])
          }else{
            member.push(state.datamembers['membersall'])
          }
          
          if(field == 'name')
            field = 'value'

          if(order == 'ascending' || order == 'asc')
            order = 'asc'
          else
            order = 'desc'

          let checkOrder:Array<any> = [];
          let _users:Array<any> = [];
          if (value.length > 2){
            if (member.length > 0){
              // Parse multiple search terms from input - split by newlines, commas, or spaces
              const searchTerms = value
                .split(/[\r\n,\s]+/)
                .map(term => term.trim())
                .filter(term => term.length > 0)
                .map(term => term.replace(/\+/g, '\\+'));
              
              var response = _.filter(member[0], (item): any => {
                // Check if any search term matches this member
                for (const searchTerm of searchTerms) {
                  const re = new RegExp(searchTerm, 'gi');
                  if (item.firstname.match(re)) {
                    item.priority=1;
                    return true
                  } else if (item.lastname != undefined && item.lastname.match(re)) {
                    item.priority=2;
                    return true
                  } else if (item.nickname != undefined && item.nickname.match(re)) {
                    item.priority=2;
                    return true
                  } else if (item.value != undefined && (item.value.match(re))) {
                    item.priority=3;
                    return true
                  } else if (item.email != undefined && item.email.match(re)) {
                    item.priority=3;
                    return true
                  } else if (item.team_name != undefined && item.team_name.match(re)) {
                    item.priority=3;
                    return true
                  } else if (item.boss_firstname != undefined && item.boss_firstname.match(re)) {
                    item.priority=3;
                    return true
                  } else if (item.boss_lastname != undefined && item.boss_lastname.match(re)) {
                    item.priority=3;
                    return true
                  } else if (item.boss_name != undefined && item.boss_name.match(re)) {
                    item.priority=3;
                    return true
                  }
                }
                return false;
              });
             
              if(state.incomplete.length > 0){
                checkOrder = _.filter(state.incomplete, { 'inorder': -999 })
                if(checkOrder.length > 1 || state.incomplete.length > 1 || (state.incomplete.length == 1 && checkOrder.length == 0)){
                  _users = _.orderBy(response, ['priority',"inorder",field], ["asc",order]);
                }else{
                  _users = _.orderBy(response, ['priority',field], [order]);
                }
              }else{
                _users = _.orderBy(response,['priority',field], [order]);
              }
              // let response_sort = _.orderBy(response, ["inorder",field], ["asc",order]);
              commit('setResults', _users)
              commit('setMember', _users.slice(0,state.size_page))
            }
          }else if(value.length == 0){
            if(state.incomplete.length > 0){
              checkOrder = _.filter(state.incomplete, { 'inorder': -999 })
              if(checkOrder.length > 1 || state.incomplete.length > 1 || (state.incomplete.length == 1 && checkOrder.length == 0)){
                _users = _.orderBy(member[0], ["inorder",field], ["asc",order]);
              }else{
                _users = _.orderBy(member[0], [field], [order]);
              }
            }else{
              _users = _.orderBy(member[0], [field], [order]);
            }
            // let response_sort = _.orderBy(member[0], ["inorder",field], ["asc",order]);
            commit('setResults', _users)
            commit('setMember', _users.slice(0,state.size_page))
          }
        },
        searchMembersArchive({commit,state}:any,value:string){
          let field = state.sortfieldarchive
          let order = state.sortorderarchive
          commit('setPageArchive',1)
          const member: Array<any> = [];
          member.push(state.membersArchiveAll)
          
          if(field == 'name')
            field = 'value'

          if(order == 'ascending' || order == 'asc')
            order = 'asc'
          else
            order = 'desc'

          if (value.length > 2){
            if (member.length > 0){
              // var re = new RegExp(value, 'gi')
              const searchTerm = value.replace(/\+/g, '\\+');
              const re = new RegExp(searchTerm, 'gi');
              var response = _.filter(member[0], (item): any => {
                if (item.firstname.match(re)) {
                  return true
                } else if (item.lastname != undefined && item.lastname.match(re)) {
                  return true
                } else if (item.nickname != undefined && item.nickname.match(re)) {
                  return true
                } else if (item.value != undefined && (item.value.match(re))) {
                  return true
                } else if (item.email != undefined && item.email.match(re)) {
                  return true
                } else if (item.team_name != undefined && item.team_name.match(re)) {
                  return true
                } else if (item.boss_firstname != undefined && item.boss_firstname.match(re)) {
                  return true
                } else if (item.boss_lastname != undefined && item.boss_lastname.match(re)) {
                  return true
                } else if (item.boss_name != undefined && item.boss_name.match(re)) {
                  return true
                }
              });
              let response_sort = _.orderBy(response, [field], [order]);
              commit('setResultsArchive', response_sort)
              commit('setMemberArchive', response_sort.slice(0,state.size_page))
            }
          }else if(value.length == 0){
            let response_sort = _.orderBy(member[0], [field], [order]);
            commit('setResultsArchive', response_sort)
            commit('setMemberArchive', response_sort.slice(0,state.size_page))
          }
        },
        statusChange({commit,state}:any,type:string){
          let field = state.sortfield
          let order = state.sortorder
          commit('setType',type)
          commit('setPage',1)
          const member: Array<any> = [];
          if(state.type == 'active'){
            member.push(state.datamembers['membersact'])
          }else if(state.type == 'inactive'){
            member.push(state.datamembers['membersinact'])
          }else if(state.type == 'new'){
            member.push(state.datamembers['membersnew'])
          }else if(state.type == 'invited'){
            member.push(state.datamembers['membersinvited'])
          }else{
            member.push(state.datamembers['membersall'])
          }
          if(field == 'name')
            field = 'value'

          if(order == 'ascending' || order == 'asc')
            order = 'asc'
          else
            order = 'desc'

          let checkOrder:Array<any> = [];
          let _users:Array<any> = [];
          if(state.incomplete.length > 0){
            checkOrder = _.filter(state.incomplete, { 'inorder': -999 })
            if(checkOrder.length > 1 || state.incomplete.length > 1 || (state.incomplete.length == 1 && checkOrder.length == 0)){
              _users = _.orderBy(member[0], ["inorder",field], ["asc",order]);
            }else{
              _users = _.orderBy(member[0], [field], [order]);
            }
          }else{
            _users = _.orderBy(member[0], [field], [order]);
          }
          // var _users = _.orderBy(member[0], ["inorder",field], ["asc",order]);
          commit('setResults',_users)
          commit('setMember', _users.slice(0,state.size_page))
        },
        updateUserType({commit}:any,value:any){
          firebase.database().ref(`/users/${value.id}`).update({
              user_type:value.type,
              modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
          }).then(()=>{
            console.log("success");
          });
        },
        inviteMember({commit,rootState,dispatch}:any,email:any){
          firebase.database().ref(`/user_invite`).push({
            email:email
          }).then(()=>{
            let Id = email.replace(/\./g, "||")
            firebase.database().ref(`/users/${Id}`).update({
              invited:format(new Date(), 'YYYY-MM-DD HH:mm:ss')
            }).then(()=>{
              commit('setPage',1)
              // setTimeout(() => {
              //   let data={...rootState.authen.user,getMember:true}
              //   dispatch('getMember',data)
              // }, 3000)
              commit('setUpdateMember',true)
              dispatch('getMember',rootState.authen.user)
            });
          })
        },
        inviteArrMember({commit,rootState,dispatch}:any,obj:any){
          if(obj.length > 0){
            _.forEach(obj, (item,key)=> {
              firebase.database().ref(`/user_invite`).push({
                email:item.email
              }).then(()=>{
                let Id = item.email.replace(/\./g, "||")
                firebase.database().ref(`/users/${Id}`).update({
                  invited:format(new Date(), 'YYYY-MM-DD HH:mm:ss')
                });
              });
            });
            commit('setPage',1)
            // setTimeout(() => {
            //   let data={...rootState.authen.user,getMember:true}
            //   dispatch('getMember',data)
            // }, 3000)
            commit('setUpdateMember',true)
            dispatch('getMember',rootState.authen.user)
          }
        },
        updateArchiveTypeMember({commit,rootState,dispatch,state}:any,value:any){
          const id=value.id
          const type=value.type.toLowerCase()
          const archive=state.membersArchive
          if(id != undefined){
                firebase.database().ref('users_employee_exit/' + id+"/archive_type").set(type, function (error) {
                  if (error) {
                    console.log('The write failed...')
                  }
                  
                }).then (()=>{
                  for(const i in archive){
                    if(archive[i].id == id){
                      archive[i].archive_type=value.type
                    }
                  }
                  commit('setMemberArchive', archive)
                  // dispatch('getArchiveData',rootState.authen.user)
                })
          }
        },
        archiveMember({commit,rootState,dispatch}:any,value:any){
          const id=value.id
          const type=value.type
          if(id != undefined){
            commit('setLoadingMemberTable',true)
            commit('setMember',[])
            // let users = firebase.database().ref('users/' + id).once('value', snapshot => {
              rootState.main.allUser[id]
              const data = rootState.main.allUser[id]
              data.archive_type=type.toLowerCase()
              if(data != undefined){
                data.exitdated = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
                firebase.database().ref('users_employee_exit/' + id).set(data, function (error) {
                  if (error) {
                    console.log('The write failed...')
                  } else {
                    firebase.database().ref('users').child(id).remove();
                  }
                }).then(()=>{
                  /*save logs*/
                  dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: id,
                    table: 'users',
                    status: 'remove',
                    type: 'user_exit',
                    user: rootState.authen.user.email
                  }, {root:true}).then(function() {
                    commit('setPage',1)
                    // setTimeout(() => {
                    //   let data={...rootState.authen.user,getMember:true}
                    //   dispatch('getMember',data)
                    // }, 3000)
                    commit('setUpdateMember',true)
                    dispatch('getMember',rootState.authen.user)
                  });
                });
              }
            // }).catch(error => {
            //   console.log(error)
            // });
          }
        },
       async setTimeArchiveMember({commit,rootState,dispatch,state}:any,value:any){
        // console.log('setTimeArchiveMember',value)
        let id=value.id
        const email=id.replace(/\||/g, '.')
        const user = await getByUser(email)//(await firebase.database().ref(`users/${id}`).once('value')).val()
          console.log('user',user)
          let archive_date=value.archive_date
          const type=value.type
          if(id != undefined){
            commit('setLoadingMemberTable',true)
            commit('setMember',[])
             await firebase.database().ref('users/' + id).update({archive_date:archive_date,archive_type:type.toLowerCase()})
              let data={...user,archive_date:archive_date,archive_type:type.toLowerCase()}
              firebase.database().ref('users_archive_schedule/'+id).update(
                data
              ).then(()=>{
                commit('setPage',1)
                // setTimeout(() => {
                //   let data={...rootState.authen.user,getMember:true}
                //   dispatch('getMember',data)
                // }, 3000)
                commit('setUpdateMember',true)
                dispatch('getMember',rootState.authen.user)
              })
              .catch(function(error) {
                console.log(error.message);
            });
            
            
  
          }
        },
        async setTimeArchiveArrMember({commit,rootState,dispatch,state}:any,value:any){
          //console.log('setTimeArchiveArrMember',value)
          const allUser = (await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
          let users_company = {};
          let users_companyid = {};
          let obj=value.arr
          let archive_date=value.archive_date
          const type=value.type
          if(obj.length > 0){
            commit('setLoadingMemberTable',true)
            _.forEach(obj, (item,key)=> {
              
              let id = item.key
              if(id != undefined){
                const user = allUser[id]
                users_company[`users_archive_schedule/${id}`] = {...user,archive_date:archive_date,archive_type:type.toLowerCase()}
                users_companyid[`users/${id}`]={...user,archive_date:archive_date,archive_type:type.toLowerCase()}
                // firebase.database().ref('users_archive_schedule').child(id).set(
                //   {...state.membersByKey[id],archive_date:archive_date}
                // ).then(()=>{
                //   console.log("users_archive_schedule")
                // })
              }
            })
            // console.log("users_companyid",users_companyid)
            // console.log("users_company",users_company)
            firebase.database().ref().update(users_company);
            firebase.database().ref().update(users_companyid);
            
          }
          commit('setPage',1)
          // setTimeout(() => {
          //   let data={...rootState.authen.user,getMember:true}
          //   dispatch('getMember',data)
          // }, 2000)
          commit('setUpdateMember',true)
          dispatch('getMember',rootState.authen.user)
          
        },
        archiveArrMember({commit,rootState,dispatch}:any,value:any){
          const obj = value.obj
          const type=value.type
          if(obj.length > 0){
            _.forEach(obj, (item,key)=> {
              let id = item.key
              if(id != undefined){
                // let users = firebase.database().ref('users/' + id).once('value', snapshot => {
                  const data = rootState.main.allUser[id]
                  data.archive_type=type.toLowerCase()
                  if(data != undefined){
                    data.exitdated = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
                    firebase.database().ref('users_employee_exit/' + id).set(data, function (error) {
                      if (error) {
                        console.log('The write failed...')
                      } else {
                        firebase.database().ref('users').child(id).remove();
                      }
                    }).then(()=>{
                      /*save logs*/
                      dispatch('authen/addLogs', {
                        company: rootState.authen.user.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        id: id,
                        table: 'users',
                        status: 'remove',
                        type: 'user_exit',
                        user: rootState.authen.user.email
                      }, {root:true})
                    });
                  }
                // }).catch(error => {
                //   console.log(error)
                // });
              }
            });
            commit('setPage',1)
            // setTimeout(() => {
            //   let data={...rootState.authen.user,getMember:true}
            //   dispatch('getMember',data)
            // }, 3000)
            commit('setUpdateMember',true)
            dispatch('getMember',rootState.authen.user)
          }
        },
        unArchiveMember({commit,rootState,dispatch}:any,id:any){
          if(id != undefined){
            commit('setLoadingArchiveTable',true)
            commit('setMemberArchive', [])
            let users = firebase.database().ref('users_employee_exit/' + id).once('value', snapshot => {
              const data = snapshot.val();
              if(data.archive_date){
                delete data.archive_date
              }
              
              if(data != undefined){
                delete data.exitdated
                firebase.database().ref('users/' + id).set(data, function (error) {
                  if (error) {
                    console.log('The write failed...')
                  } else {
                    
                    firebase.database().ref('users_employee_exit').child(id).remove();
                  }
                }).then(()=>{
                  /*save logs*/
                  dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: id,
                    table: 'users_employee_exit',
                    status: 'remove',
                    type: 'user_unarchive',
                    user: rootState.authen.user.email
                  }, {root:true}).then(function() {
                    commit('setPageArchive',1)
                    dispatch('getArchiveData',rootState.authen.user)
                    
                    commit('setPage',1)
                    // console.log('unArchive')
                    // setTimeout(() => {
                    //   let data={...rootState.authen.user,getMember:true}
                    //   dispatch('getMember',data)
                    // }, 3000)
                    commit('setUpdateMember',true)
                    dispatch('getMember',rootState.authen.user)
                  });
                });
              }
            }).catch(error => {
              console.log(error)
            });
          }
        },
        unArchiveScheduleMember({commit,rootState,dispatch,state}:any,id:any){
          //console.log('unArchiveScheduleMember',id)
            commit('setLoadingArchiveTable',true)
            commit('setMemberArchive', [])
              if(id != undefined){
                firebase.database().ref(`users/${id}/archiveSchedule`).remove();
                firebase.database().ref(`users/${id}/archive_type`).remove();
                firebase.database().ref(`users/${id}/archive_date`).remove();
                firebase.database().ref('users_archive_schedule').child(id).remove();
                state.userArchivedSchedule=_.filter(
                  state.userArchivedSchedule,
                  function (currentObject) {
                    return currentObject.key!== id;
                  }
                );
              }

            
            commit('setPageArchive',1)

            dispatch('getArchiveData',rootState.authen.user)
            
            commit('setPage',1)
            // setTimeout(() => {
            //   let data={...rootState.authen.user,getMember:true}
            //   dispatch('getMember',data)
            // }, 3000)
            commit('setUpdateMember',true)
            dispatch('getMember',rootState.authen.user)
        },
        unArchiveArrMember({commit,rootState,dispatch}:any,obj:any){
          //console.log('unArchiveArrMember',obj)
          if(obj.length > 0){
            commit('setLoadingArchiveTable',true)
            commit('setMemberArchive', [])
            _.forEach(obj, (item,key)=> {
              let id = item.key
              if(id != undefined){
                let users = firebase.database().ref('users_employee_exit/' + id).once('value', snapshot => {
                  const data = snapshot.val();
                  
                  if(data != undefined){
                    delete data.exitdated
                    if(data.archive_date){
                      delete data.archive_date
                    }
                    firebase.database().ref('users/' + id).set(data, function (error) {
                      if (error) {
                        console.log('The write failed...')
                      } else {
                        firebase.database().ref('users_employee_exit').child(id).remove();
                      }
                    }).then(()=>{
                      /*save logs*/
                      dispatch('authen/addLogs', {
                        company: rootState.authen.user.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        id: id,
                        table: 'users_employee_exit',
                        status: 'remove',
                        type: 'user_unarchive',
                        user: rootState.authen.user.email
                      }, {root:true})
                    });
                  }
                }).catch(error => {
                  console.log(error)
                });
              }
            });
            commit('setPageArchive',1)
            dispatch('getArchiveData',rootState.authen.user)
            
            commit('setPage',1)
            // setTimeout(() => {
            //   console.log('arrUnarchive')
            //   let data={...rootState.authen.user,getMember:true}
            //   dispatch('getMember',data)
            // }, 4000)
            commit('setUpdateMember',true)
            dispatch('getMember',rootState.authen.user)
          }
        },
        unArchiveArrMemberSchedule({commit,rootState,dispatch,state}:any,obj:any){
          //console.log('unArchiveArrMemberSchedule',obj)
          if(obj.length > 0){
            commit('setLoadingArchiveTable',true)
            commit('setMemberArchive', [])
            _.forEach(obj, (item,key)=> {
              let id = item.key
              if(id != undefined){
                firebase.database().ref(`users/${id}/archiveSchedule`).remove();
                firebase.database().ref(`users/${id}/archive_type`).remove();
                firebase.database().ref(`users/${id}/archive_date`).remove();
                firebase.database().ref('users_archive_schedule').child(id).remove();
                state.userArchivedSchedule=_.filter(
                  state.userArchivedSchedule,
                  function (currentObject) {
                    return currentObject.key!== id;
                  }
                );
              }

            });
           
            commit('setPageArchive',1)

            dispatch('getArchiveData',rootState.authen.user)
            
            commit('setPage',1)
            // setTimeout(() => {
            //   let data={...rootState.authen.user,getMember:true}
            //   dispatch('getMember',data)
            // }, 3000)
            commit('setUpdateMember',true)
            dispatch('getMember',rootState.authen.user)
          }
        },
        deleteArchiveMember({commit,rootState,dispatch}:any,id:any){
          if(id != undefined){
            commit('setLoadingArchiveTable',true)
            commit('setMemberArchive', [])
            firebase.database().ref('users_employee_exit').child(id).remove()
            firebase.database().ref(`/users_company/${rootState.authen.user.company}/${id}`).remove()
            /* Start clear important data in db */
            const dataAdd = {
              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
              email: id
            }
            firebase.database().ref('users_cleardata').push(dataAdd)
            /* End clear important data in db */
            /*save logs*/
            dispatch('authen/addLogs', {
              company: rootState.authen.user.company,
              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
              id: id,
              table: 'users_employee_exit',
              status: 'remove',
              type: 'user_invalid',
              user: rootState.authen.user.email
            }, {root:true}).then(function() {
              commit('setPageArchive',1)
              dispatch('getArchiveData',rootState.authen.user)
            });
          }
        },
        deleteArchiveArrMember({commit,rootState,dispatch}:any,obj:any){
          if(obj.length > 0){
            _.forEach(obj, (item,key)=> {
              let id = item.key
              if(id != undefined){
                firebase.database().ref('users_employee_exit').child(id).remove()
                firebase.database().ref(`/users_company/${rootState.authen.user.company}/${id}`).remove()
                /* Start clear important data in db */
                const dataAdd = {
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  email: id
                }
                firebase.database().ref('users_cleardata').push(dataAdd)
                /* End clear important data in db */
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: rootState.authen.user.company,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: id,
                  table: 'users_employee_exit',
                  status: 'remove',
                  type: 'user_invalid',
                  user: rootState.authen.user.email
                }, {root:true})
              }
            });
            commit('setPageArchive',1)
            dispatch('getArchiveData',rootState.authen.user)
          }
        },
        async deleteAllArchiveMember({commit,rootState,dispatch}:any){
          await firebase.database().ref().child('users_employee_exit').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value',async snapshot => {
            snapshot.forEach((arrData):any => {
              const id = arrData.key
              if(id != undefined){
                firebase.database().ref('users_employee_exit').child(id).remove()
                firebase.database().ref(`/users_company/${rootState.authen.user.company}/${id}`).remove()
                /* Start clear important data in db */
                const dataAdd = {
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  email: id
                }
                firebase.database().ref('users_cleardata').push(dataAdd)
                /* End clear important data in db */
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: rootState.authen.user.company,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: id,
                  table: 'users_employee_exit',
                  status: 'remove',
                  type: 'user_invalid',
                  user: rootState.authen.user.email
                }, {root:true})
              }
            });
            commit('setPageArchive',1)
            dispatch('getArchiveData',rootState.authen.user)
          }).catch(error => {
            console.log(error)
          });
        },
        sortMember({commit,state}:any,value:any){
          var member: Array<any> = [];
          if(state.type == 'active'){
            member.push(state.datamembers['membersact'])
          }else if(state.type == 'inactive'){
            member.push(state.datamembers['membersinact'])
          }else if(state.type == 'new'){
            member.push(state.datamembers['membersnew'])
          }else if(state.type == 'invited'){
            member.push(state.datamembers['membersinvited'])
          }else{
            member.push(state.datamembers['membersall'])
          }
          if (state.inputSearch.length > 2){
            if (member.length > 0){
              var re = new RegExp(state.inputSearch, 'gi')
              var response = _.filter(member[0], (item): any => {
                if (item.firstname.match(re)) {
                  item.priority=1;
                  return true
                } else if (item.lastname != undefined && item.lastname.match(re)) {
                  item.priority=2;
                  return true
                } else if (item.value != undefined && (item.value.match(re))) {
                  item.priority=3;
                  return true
                } else if (item.email != undefined && item.email.match(re)) {
                  item.priority=3;
                  return true
                } else if (item.team_name != undefined && item.team_name.match(re)) {
                  item.priority=3;
                  return true
                } else if (item.boss_firstname != undefined && item.boss_firstname.match(re)) {
                  item.priority=3;
                  return true
                } else if (item.boss_lastname != undefined && item.boss_lastname.match(re)) {
                  item.priority=3;
                  return true
                } else if (item.boss_name != undefined && item.boss_name.match(re)) {
                  item.priority=3;
                  return true
                }
              });
              member = []
              member.push(response)
            }
          }

          var size = state.size_page
          var page = state.page
          var field  = value[0]
          var order = value[1]
          var start_row = (page-1) * size
          var end_row = ((page-1) * size)+size
          if(field == 'name')
            field = 'value'

          if(order == 'ascending' || order == 'asc')
            order = 'asc'
          else
            order = 'desc'
          
          let checkOrder:Array<any> = [];
          let _users:Array<any> = [];
          if(state.incomplete.length > 0){
            checkOrder = _.filter(state.incomplete, { 'inorder': -999 })
            if(checkOrder.length > 1 || state.incomplete.length > 1 || (state.incomplete.length == 1 && checkOrder.length == 0)){
              _users = _.orderBy(member[0], ['priority',"inorder",field], ["asc",order]);
            }else{
              _users = _.orderBy(member[0], ['priority',field], [order]);
            }
          }else{
            _users = _.orderBy(member[0], ['priority',field], [order]);
          }
          // var _users = _.orderBy(member[0], ["inorder",field], ["asc",order]);
          commit('setSortfield', field)
          commit('setSortorder', order)
          commit('setMember', _users.slice(start_row,end_row))
        },
        sortMemberArchive({commit,state}:any,value:any){
          var member: Array<any> = [];
          member.push(state.membersArchiveAll)
          if (state.inputSearchArchive.length > 2){
            if (member.length > 0){
              var re = new RegExp(state.inputSearchArchive, 'gi')
              var response = _.filter(member[0], (item): any => {
                if (item.firstname.match(re)) {
                  return true
                } else if (item.lastname != undefined && item.lastname.match(re)) {
                  return true
                } else if (item.value != undefined && (item.value.match(re))) {
                  return true
                } else if (item.email != undefined && item.email.match(re)) {
                  return true
                } else if (item.team_name != undefined && item.team_name.match(re)) {
                  return true
                } else if (item.boss_firstname != undefined && item.boss_firstname.match(re)) {
                  return true
                } else if (item.boss_lastname != undefined && item.boss_lastname.match(re)) {
                  return true
                } else if (item.boss_name != undefined && item.boss_name.match(re)) {
                  return true
                }
              });
              member = []
              member.push(response)
            }
          }

          var size = state.size_page
          var page = state.pagearchive
          var field  = value[0]
          var order = value[1]
          var start_row = (page-1) * size
          var end_row = ((page-1) * size)+size

          if(field == 'name')
            field = 'value'

          // Special handling for archiveddate sorting
          if(field == 'archiveddate') {
            field = 'archived_timestamp'
          }

          // Impact rating and network type sort as-is (numeric and alphabetic respectively)

          if(order == 'ascending' || order == 'asc'){
            if(field == 'exitdated'){
              order = 'desc'
            }else {
              order = 'asc'
            }
          }else {
            if(field == 'exitdated'){
              order = 'asc'
            }else{
              order = 'desc'
            }
          }
          var _users = _.orderBy(member[0], [field], [order]);
          commit('setSortfieldArchive', field)
          commit('setSortorderArchive', order)
          commit('setMemberArchive', _users.slice(start_row,end_row))
        },
        async getRelationshipMobile({commit,dispatch,state,rootState}:any, item:any){
          let bytes  = CryptoJS.AES.decrypt(item.code, 'HappilyRelationShip');
          let originalText = bytes.toString(CryptoJS.enc.Utf8);
          let codeSplit = originalText.split("===")
          let arrData:Array<any> = [];
          let relationships:any = {}
          if(codeSplit[1]){
            var keyId = codeSplit[1].replace(/\./g, "||")
            var userData = await getByUser(codeSplit[1])//(await firebase.database().ref(`/users/${keyId}`).once('value')).val()
          }
          const rel_maps = (await firebase.database().ref(`/rel_maps/${keyId}`).once('value')).val()
          const houseData:Array<any> = [];
          houseData['-LWOr-XsbZM2digYl1QL'] = new Array()
          houseData['-LWOr-XsbZM2digYl1QL']['color'] = '#1d97f2'
          houseData['-LWPrOElCYViBd6j6qP-'] = new Array()
          houseData['-LWPrOElCYViBd6j6qP-']['color'] = '#ffbf1f'
          houseData['-LWPrZbcyHAVHIFUsWLd'] = new Array()
          houseData['-LWPrZbcyHAVHIFUsWLd']['color'] = '#ea183c'
          relationships.center = codeSplit[1]
          relationships.firstname = userData.firstname
          relationships.lastname = userData.lastname
          if(userData.profilepic_small){
            relationships.pic = userData.profilepic_small;
          }else if (userData.profilepic_crop){
            relationships.pic = userData.profilepic_crop;
          }else if (userData.profilepic){
            relationships.pic = userData.profilepic;
          }else {
            relationships.pic = "";
          }
          relationships.house_color = (houseData[userData.house] && houseData[userData.house].color) ? houseData[userData.house].color : ''
          relationships.dist_map = new Array()
          relationships.node_relations = new Array() 
          if(rel_maps && rel_maps.dists.length > 0){
            _.forEach(rel_maps.dists, (value,key)=> {
              let _item:any = value
              _item.distance = value.dist_norm
              _item.name = (value.team_name) ? value.team_name : ''
              _item.house_color = (value.house_id) ? houseData[value.house_id].color : ''
              _item.pic = value.pic;
              _item.firstname = value.firstname
              _item.lastname = value.lastname
              relationships.dist_map.push(_item)
            });
            _.forEach(rel_maps.edges, (value,key)=> {
              let _item:any = value
              relationships.node_relations.push(_item)
            });
          }
          arrData['relationships'] = relationships
          commit('setWebViewData', arrData)
        },
        async getPersonalContext({commit,dispatch,state}:any, item:any){
          const personalContext = (await firebase.database().ref(`/users_context/${item.key}`).once('value')).val()
          commit('setPersonalContext', _.get(personalContext, 'context'))
        },
        async exportPersonalContext({commit,state,rootState}:any){
          console.log("exportPersonalContext action started");
          try {
            // Get all active members
            const members = state.results || []
            console.log("Found total members:", members.length);
            
            if (members.length === 0) {
              throw new Error('No members found to export')
            }

            // Helper function to generate markdown header
            const generateMarkdownHeader = (memberCount: number) => {
              const currentDate = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
              return `# Organization Personal Context Data
Generated: ${currentDate}
Total Members: ${memberCount}

## Executive Summary
This document contains personal context data for all active members of the organization, including values, skills, personality traits, communication styles, and recent challenges. The data is formatted for AI analysis to identify patterns, skill gaps, team dynamics, and provide actionable insights.

## Member Profiles

`
            }

            // Helper function to generate member markdown
            const generateMemberMarkdown = (member: any, personalContext: any) => {
              let markdown = `### ${member.firstname || 'Unknown'} ${member.lastname || ''} - ${member.email}
**Team:** ${member.team_name || member.dispteam || 'Not specified'}
**Status:** ${member.status || 'active'}
**Joined:** ${member.joined || 'Unknown'}
**User Type:** ${member.user_type || 'user'}

`

              if (personalContext) {
                // Personal Values
                if (personalContext.values && personalContext.values.length > 0) {
                  markdown += `#### Personal Values
${personalContext.values.map((value: string) => `- ${value}`).join('\n')}

`
                }

                // Skills & Competencies
                if (personalContext.skills && personalContext.skills.length > 0) {
                  markdown += `#### Skills & Competencies
${personalContext.skills.map((skill: string) => `- ${skill}`).join('\n')}

`
                }

                // Personality & Communication
                markdown += `#### Personality & Communication
`
                if (personalContext.personality) {
                  markdown += `**Personality Traits:** ${personalContext.personality}
`
                }
                if (personalContext.communication_style) {
                  markdown += `**Communication Style:** ${personalContext.communication_style}
`
                }

                // Role Focus
                if (personalContext.general_info && personalContext.general_info.role_focus) {
                  markdown += `
#### Role Focus
${personalContext.general_info.role_focus}

`
                }

                // Recent Challenges
                if (personalContext.recent_challenges && personalContext.recent_challenges.length > 0) {
                  markdown += `#### Recent Challenges
${personalContext.recent_challenges.map((challenge: string) => `- ${challenge}`).join('\n')}

`
                }
              } else {
                markdown += `#### Personal Context
*No personal context data available for this member*

`
              }

              // Add network metrics if available
              if (member.culture_add_percentile) {
                markdown += `#### Network Metrics
- **Culture Add Score:** Top ${member.culture_add_percentile}%

`
              }

              markdown += `---

`
              return markdown
            }

            // Helper function to generate analysis prompts
            const generateAnalysisPrompts = () => {
              return `## Aggregate Analysis Prompts

### Suggested AI Analysis Questions:

#### 1. Skills Analysis
- What are the most common skills gaps across the organization?
- Which skills are most represented vs. which need improvement?
- How do skill distributions vary by team or role?

#### 2. Team Dynamics
- Which personality combinations would work best together?
- What communication style conflicts might arise in teams?
- Which members could serve as mentors for others?

#### 3. Organizational Health
- What are the primary challenges facing the organization?
- Which teams or roles face similar challenges?
- Are there patterns in values that indicate cultural alignment?

#### 4. Network Analysis
- Who are the key influencers based on recognition patterns?
- Which employees might benefit from additional support?
- How do culture add scores correlate with other factors?

#### 5. Development Opportunities
- Which members show potential for leadership roles?
- What training programs would benefit the most people?
- How can skill gaps be addressed through internal mentoring?

#### 6. Risk Assessment
- Which employees may need additional engagement?
- Are there early warning signs of potential issues?
- How do recent challenges cluster across teams?

### Analysis Instructions for AI:
1. Look for patterns across the entire dataset
2. Consider both individual and team-level insights
3. Identify opportunities for improvement and growth
4. Suggest actionable recommendations
5. Highlight any concerning trends that need attention
6. Focus on data-driven insights rather than assumptions

### Data Privacy Note:
This data is confidential and should be used only for organizational development purposes. Ensure compliance with privacy policies when processing.
`
            }

            // Helper function to download markdown file
            const downloadMarkdownFile = (content: string) => {
              const blob = new Blob([content], { type: 'text/markdown;charset=utf-8;' })
              const link = document.createElement('a')
              const url = URL.createObjectURL(blob)
              const currentDate = format(new Date(), 'YYYY-MM-DD')
              const memberCount = members.length
              
              link.setAttribute('href', url)
              link.setAttribute('download', `Personal_Context_Export_${currentDate}_${memberCount}Members.md`)
              link.style.visibility = 'hidden'
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              URL.revokeObjectURL(url)
            }

            // Generate the content
            let markdownContent:any = generateMarkdownHeader(members.length)
            
            // Fetch personal context data for company members only
            console.log("Fetching personal context data for company members...");
            const memberKeys = members.map(member => member.key);
            console.log(`Fetching context for ${memberKeys.length} company members`);
            
            // Create batch requests for only our company's members
            const contextPromises:any = memberKeys.map(async (key) => {
              try {
                const contextData = await firebase.database().ref(`/users_context/${key}`).once('value');
                return { key, data: contextData.val() };
              } catch (error) {
                console.warn(`Failed to fetch context for ${key}:`, error);
                return { key, data: null };
              }
            });
            
            // Execute all requests in parallel (much faster than sequential)
            const contextResults:any = await Promise.all(contextPromises);
            
            // Convert to lookup object
            const allPersonalContextData: any = {};
            contextResults.forEach(result => {
              if (result.data) {
                allPersonalContextData[result.key] = result.data;
              }
            });
            
            console.log("Batch fetch completed. Processing members...");
            
            // Process each member with their context data
            let processedCount = 0;
            for (const member of members) {
              try {
                const personalContextData:any = allPersonalContextData[member.key]
                const personalContext:any = _.get(personalContextData, 'context')
                
                // Generate markdown for this member
                markdownContent += generateMemberMarkdown(member, personalContext)
                processedCount++;
                
                if (processedCount % 50 === 0) {
                  console.log(`Processed ${processedCount}/${members.length} members`);
                }
              } catch (error) {
                console.warn(`Failed to process context for ${member.email}:`, error)
                // Continue with other members
                markdownContent += generateMemberMarkdown(member, null)
                processedCount++;
              }
            }
            
            console.log("Finished processing all members. Creating download...");
            
            // Add aggregate analysis prompts
            markdownContent += generateAnalysisPrompts()
            
            // Download the file
            downloadMarkdownFile(markdownContent)
            
          } catch (error) {
            console.error('Export personal context failed:', error)
            throw error
          }
        },
        async getModalMemberData({commit,dispatch,state}:any, item:any){
          let arrData:Array<any> = [];
          let topskill:Array<any> = [];
          let peerfeedback = {}
          state.modalMemberData = []
          const typeMaster = (await firebase.database().ref('achievement_type').orderByChild("order_by").once('value')).val()
          await firebase.firestore().collection('users_achievements/').doc(item.email).get().then( async(doc)=> {
            if (doc.exists) {
              const _data:any = doc.data()
                if(_data.peerfeedback) peerfeedback = _data.peerfeedback
                if(_data.peerfeedback_unique){
                  for(const x in _data.peerfeedback_unique){
                      topskill.push({
                          key:x,
                          value:_data.peerfeedback_unique[x],
                      });
                  }
                  arrData['topskill'] = _.orderBy(topskill, ['value'],['desc'])
                }
                const arrAch:Array<any> = [];
                const achievement_type:Array<any> = [];
                arrData['achievements_total'] = 0
                await firebase.firestore().collection('users_achievements/').doc(item.email).collection('achievements').get()
                .then(async function (querySnapshot) {
                    querySnapshot.forEach(function (docAch) {
                      const _dataAch = docAch.data()
                      if(_dataAch.count1 == _dataAch.count1_total){
                        if (arrAch[_dataAch.type] === undefined) {
                          arrAch[_dataAch.type] = new Array();
                          arrAch[_dataAch.type].count = 0
                        }
                        if(_dataAch.count2){
                          if(_dataAch.count2 == _dataAch.count2_total){
                            arrAch[_dataAch.type].count += 1
                            arrData['achievements_total'] += 1
                          }
                        }else{
                          arrAch[_dataAch.type].count += 1
                          arrData['achievements_total'] += 1
                        }
                      }
                    });
                    if(peerfeedback){
                      let sort_peerfeedback = Object.keys(peerfeedback).sort(function(a,b){return peerfeedback[b] - peerfeedback[a]})
                      arrData['peerfeedback'] = new Object()
                      _.forEach(sort_peerfeedback, (value,key)=> {
                          arrData['peerfeedback'][value] = peerfeedback[value]
                      });
                    }
                    if(arrAch){
                      _.forEach(typeMaster, (value,key)=> {
                          let _data = value
                          if(_data.name && arrAch[_data.name]){
                              _data.count = arrAch[value.name]['count']
                          }else{
                              _data.count = 0
                          }
                          achievement_type.push(_data)
                      });
                      const achievement_type_order = _.orderBy(achievement_type, ['count'],['desc']);
                      arrData['achievements'] = achievement_type_order
                    }
                  await firebase.firestore().collection('here_point').where('send_to_email','==',item.email).where('hash','==',true).get()
                    .then(function (querySnapshot) {
                        const check:Array<any> = [];
                        const hashtagskey:Array<any> = [];
                        const hashtags:Array<any> = [];
                        querySnapshot.forEach(function (doc) {
                            for(const x in doc.data().hashtag){
                                if(!check[doc.data().sender_email+'='+doc.data().hashtag[x]]){
                                    check[doc.data().sender_email+'='+doc.data().hashtag[x]] = true;
                                    if(!hashtagskey[doc.data().hashtag[x]]) hashtagskey[doc.data().hashtag[x]] = 0;
                                    hashtagskey[doc.data().hashtag[x]]++;
                                }
                            }
                        });
                        for(const x in hashtagskey){
                            hashtags.push({
                                key:x,
                                value:hashtagskey[x],
                            });
                        }
                        arrData['cultureAdd'] = _.orderBy(hashtags, ['value'],['desc'])
                    });
                  });
            }
          });
          let relationships:any = {}
          const rel_maps = (await firebase.database().ref(`/rel_maps/${item.key}`).once('value')).val()
          const houseData:Array<any> = [];
          houseData['-LWOr-XsbZM2digYl1QL'] = new Array()
          houseData['-LWOr-XsbZM2digYl1QL']['color'] = '#1d97f2'
          houseData['-LWPrOElCYViBd6j6qP-'] = new Array()
          houseData['-LWPrOElCYViBd6j6qP-']['color'] = '#ffbf1f'
          houseData['-LWPrZbcyHAVHIFUsWLd'] = new Array()
          houseData['-LWPrZbcyHAVHIFUsWLd']['color'] = '#ea183c'
          relationships.center = item.email
          relationships.firstname = item.firstname
          relationships.lastname = item.lastname
          relationships.pic = item.pic
          relationships.house_color = (houseData[item.house] && houseData[item.house].color) ? houseData[item.house].color : ''
          relationships.dist_map = new Array()
          relationships.node_relations = new Array() 
          if(rel_maps && rel_maps.dists.length > 0){
            _.forEach(rel_maps.dists, (value,key)=> {
              let _item:any = value
              _item.distance = value.dist_norm
              _item.name = (value.team_name) ? value.team_name : ''
              _item.house_color = (value.house_id) ? houseData[value.house_id].color : ''
              _item.pic = value.pic;
              _item.firstname = value.firstname
              _item.lastname = value.lastname
              relationships.dist_map.push(_item)
            });
            _.forEach(rel_maps.edges, (value,key)=> {
              let _item:any = value
              relationships.node_relations.push(_item)
            });
          }
          arrData['relationships'] = relationships
          
          let arrBoss:Array<any> = [];
          let tempItem:any
          let sub =  _.filter(state.datamembers['membersall'], { 'boss': item.email })
          let _userData = state.membersByKey[item.key]
          if(_userData){
            _userData.direct_report = (sub.length > 0) ? sub.length : 0
            arrBoss.push(_userData)
          }
          
          if(item.boss && (state.membersByKey[item.boss.replace(/\./g, "||")] != undefined)){
            tempItem = item
          do{
            let keyIdBoss = tempItem.boss.replace(/\./g, "||")
            let subOfBoss =  _.filter(state.datamembers['membersall'], { 'boss': tempItem.boss })
            let u = state.membersByKey[keyIdBoss]
            if(u){
              u.direct_report = (subOfBoss.length > 0) ? subOfBoss.length : 0
              arrBoss.push(u)
            }
            // Fix: newmember.ts:2941 Uncaught (in promise) TypeError: Cannot read properties of undefined (reading 'boss')
            // when delete user, u is undefined
            if(u && u.boss){
              tempItem = u
            }else{
              tempItem = []
            }
          }
          while(tempItem.boss)
          }
          arrData['org'] = arrBoss.reverse()

          dispatch('getPersonalContext', item)

          var axios = require('axios');
          var data = JSON.stringify({
          "company": item.company,
          "users": [
              item.email,
          ]
          });

          var config = {
              method: 'post',
              url: 'https://api-node.happily.ai/leaderboard/get',
              headers: { 
                  'Content-Type': 'application/json'
              },
              data : data
          };

          axios(config)
          .then(function (response) {
              const data = response.data
              if(data.data && data.data[item.email]){
                  arrData['leaderboard'] = _.orderBy(data.data[item.email], ['rank_all'],['asc'])
              }
              arrData['from'] = 'members'
              commit('setModalMemberData', arrData)
          })
          .catch(function (error) {
              console.log(error);
          });
        },
        // async getModalMemberData({commit,dispatch,state}:any, item:any){
        //   let arrData:Array<any> = [];
        //   let topskill:Array<any> = [];
        //   let peerfeedback = {}
        //   state.modalMemberData = []
        //   const typeMaster = (await firebase.database().ref('achievement_type').orderByChild("order_by").once('value')).val()
        //   await firebase.firestore().collection('users_achievements/').doc(item.email).get().then( async(doc)=> {
        //     if (doc.exists) {
        //       const _data:any = doc.data()
        //         if(_data.peerfeedback) peerfeedback = _data.peerfeedback
        //         if(_data.peerfeedback_unique){
        //           for(const x in _data.peerfeedback_unique){
        //               topskill.push({
        //                   key:x,
        //                   value:_data.peerfeedback_unique[x],
        //               });
        //           }
        //           arrData['topskill'] = _.orderBy(topskill, ['value'],['desc'])
        //         }
        //         const arrAch:Array<any> = [];
        //         const achievement_type:Array<any> = [];
        //         arrData['achievements_total'] = 0
        //         await firebase.firestore().collection('users_achievements/').doc(item.email).collection('achievements').get()
        //         .then(async function (querySnapshot) {
        //             querySnapshot.forEach(function (docAch) {
        //               const _dataAch = docAch.data()
        //               if(_dataAch.count1 == _dataAch.count1_total){
        //                 if (arrAch[_dataAch.type] === undefined) {
        //                   arrAch[_dataAch.type] = new Array();
        //                   arrAch[_dataAch.type].count = 0
        //                 }
        //                 if(_dataAch.count2){
        //                   if(_dataAch.count2 == _dataAch.count2_total){
        //                     arrAch[_dataAch.type].count += 1
        //                     arrData['achievements_total'] += 1
        //                   }
        //                 }else{
        //                   arrAch[_dataAch.type].count += 1
        //                   arrData['achievements_total'] += 1
        //                 }
        //               }
        //             });
        //             if(peerfeedback){
        //               let sort_peerfeedback = Object.keys(peerfeedback).sort(function(a,b){return peerfeedback[b] - peerfeedback[a]})
        //               arrData['peerfeedback'] = new Object()
        //               _.forEach(sort_peerfeedback, (value,key)=> {
        //                   arrData['peerfeedback'][value] = peerfeedback[value]
        //               });
        //             }
        //             if(arrAch){
        //               _.forEach(typeMaster, (value,key)=> {
        //                   let _data = value
        //                   if(_data.name && arrAch[_data.name]){
        //                       _data.count = arrAch[value.name]['count']
        //                   }else{
        //                       _data.count = 0
        //                   }
        //                   achievement_type.push(_data)
        //               });
        //               const achievement_type_order = _.orderBy(achievement_type, ['count'],['desc']);
        //               arrData['achievements'] = achievement_type_order
        //             }
        //           await firebase.firestore().collection('here_point').where('send_to_email','==',item.email).where('hash','==',true).get()
        //             .then(function (querySnapshot) {
        //                 const check:Array<any> = [];
        //                 const hashtagskey:Array<any> = [];
        //                 const hashtags:Array<any> = [];
        //                 querySnapshot.forEach(function (doc) {
        //                     for(const x in doc.data().hashtag){
        //                         if(!check[doc.data().sender_email+'='+doc.data().hashtag[x]]){
        //                             check[doc.data().sender_email+'='+doc.data().hashtag[x]] = true;
        //                             if(!hashtagskey[doc.data().hashtag[x]]) hashtagskey[doc.data().hashtag[x]] = 0;
        //                             hashtagskey[doc.data().hashtag[x]]++;
        //                         }
        //                     }
        //                 });
        //                 for(const x in hashtagskey){
        //                     hashtags.push({
        //                         key:x,
        //                         value:hashtagskey[x],
        //                     });
        //                 }
        //                 arrData['cultureAdd'] = _.orderBy(hashtags, ['value'],['desc'])
        //             });
        //           });
        //     }
        //   });
        //   let relationships:any = {}
        //   const rel_maps = (await firebase.database().ref(`/rel_maps/${item.key}`).once('value')).val()
        //   const houseData:Array<any> = [];
        //   houseData['-LWOr-XsbZM2digYl1QL'] = new Array()
        //   houseData['-LWOr-XsbZM2digYl1QL']['color'] = '#1d97f2'
        //   houseData['-LWPrOElCYViBd6j6qP-'] = new Array()
        //   houseData['-LWPrOElCYViBd6j6qP-']['color'] = '#ffbf1f'
        //   houseData['-LWPrZbcyHAVHIFUsWLd'] = new Array()
        //   houseData['-LWPrZbcyHAVHIFUsWLd']['color'] = '#ea183c'
        //   relationships.center = item.email
        //   relationships.firstname = item.firstname
        //   relationships.lastname = item.lastname
        //   relationships.pic = item.pic
        //   relationships.house_color = (houseData[item.house] && houseData[item.house].color) ? houseData[item.house].color : ''
        //   relationships.dist_map = new Array()
        //   relationships.node_relations = new Array() 
        //   if(rel_maps && rel_maps.dists.length > 0){
        //     _.forEach(rel_maps.dists, (value,key)=> {
        //       let _item:any = value
        //       _item.distance = value.dist_norm
        //       _item.name = (value.team_name) ? value.team_name : ''
        //       _item.house_color = (value.house_id) ? houseData[value.house_id].color : ''
        //       _item.pic = value.pic;
        //       _item.firstname = value.firstname
        //       _item.lastname = value.lastname
        //       relationships.dist_map.push(_item)
        //     });
        //     _.forEach(rel_maps.edges, (value,key)=> {
        //       let _item:any = value
        //       relationships.node_relations.push(_item)
        //     });
        //   }
        //   arrData['relationships'] = relationships
          
        //   let arrBoss:Array<any> = [];
        //   let tempItem:any
        //   let sub =  _.filter(state.datamembers['membersall'], { 'boss': item.email })
        //   let _userData = state.membersByKey[item.key]
        //   if(_userData){
        //     _userData.direct_report = (sub.length > 0) ? sub.length : 0
        //     arrBoss.push(_userData)
        //   }
          
        //   if(item.boss && (state.membersByKey[item.boss.replace(/\./g, "||")] != undefined)){
        //     tempItem = item
        //   do{
        //     let keyIdBoss = tempItem.boss.replace(/\./g, "||")
        //     let subOfBoss =  _.filter(state.datamembers['membersall'], { 'boss': tempItem.boss })
        //     let u = state.membersByKey[keyIdBoss]
        //     if(u){
        //       u.direct_report = (subOfBoss.length > 0) ? subOfBoss.length : 0
        //       arrBoss.push(u)
        //     }
        //     if(u.boss){
        //       tempItem = u
        //     }else{
        //       tempItem = []
        //     }
        //   }
        //   while(tempItem.boss)
        //   }
        //   arrData['org'] = arrBoss.reverse()

        //   var axios = require('axios');
        //   var data = JSON.stringify({
        //   "company": item.company,
        //   "users": [
        //       item.email,
        //   ]
        //   });

        //   var config = {
        //       method: 'post',
        //       url: 'https://api-node.happily.ai/leaderboard/get',
        //       headers: { 
        //           'Content-Type': 'application/json'
        //       },
        //       data : data
        //   };

        //   axios(config)
        //   .then(function (response) {
        //       const data = response.data
        //       if(data.data && data.data[item.email]){
        //           arrData['leaderboard'] = _.orderBy(data.data[item.email], ['rank_all'],['asc'])
        //       }
        //       arrData['from'] = 'members'
        //       commit('setModalMemberData', arrData)
        //   })
        //   .catch(function (error) {
        //       console.log(error);
        //   });
        // },
        async assignManagerSubmit({commit,rootState,dispatch,state}:any, objData:any){
          commit('setLoadingMemberTable',true)
          commit('setMember',[])
          let member = objData.memberData
          let manager = objData.manager
          const userComp = rootState.authen.user.company
          if(member && manager){
            _.forEach(member, (item,key)=> {
              firebase.database().ref(`/users/${item.key}`).update({
                boss:manager,
                modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
              }).then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: userComp,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: item.key,
                  table: 'users',
                  status: 'assignManager',
                  user: rootState.authen.user.email
                }, {root:true})
              });
            });
            firebase.database().ref(`/genboss`).push({
              company:userComp
            }).then(function() {
              commit('setPage',1)
              // setTimeout(() => {
              //   let data={...rootState.authen.user,getMember:true}
              //   dispatch('getMember',data)
              // }, 3000)
              commit('setUpdateMember',true)
              dispatch('getMember',rootState.authen.user)
            });
          }
        },
        async ReAssignManagerSubmit({commit,rootState,dispatch,state}:any, objData:any){
          commit('setLoadingMemberTable',true)
          commit('setMember',[])
          let member = objData.memberData
          let manager = objData.manager
          const userComp = rootState.authen.user.company
          if(member && manager){
            _.forEach(member, (item,key)=> {
              let data = {}
              if(item.email == manager){
                data['boss'] = ""
              }else{
                data['boss'] = manager
              }
              data['modifydatetime'] = format(new Date(), 'YYYY-MM-DD HH:mm')
              
              firebase.database().ref(`/users/${item.key}`).update(data).then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: userComp,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: item.key,
                  table: 'users',
                  status: 'ReAssignManager',
                  user: rootState.authen.user.email
                }, {root:true})
              });
            });
            firebase.database().ref(`/genboss`).push({
              company:userComp
            }).then(function() {
              firebase.database().ref(`/genorganize`).push({
                company:userComp
              })
              commit('setPage',1)
              // setTimeout(() => {
              //   let data={...rootState.authen.user,getMember:true}
              //   dispatch('getMember',data)
              // }, 3000)
              commit('setUpdateMember',true)
              dispatch('getMember',rootState.authen.user)
            });
          }
        },
        async assignTeamSubmit({commit,rootState,dispatch,state}:any, objData:any){
          commit('setLoadingMemberTable',true)
          commit('setMember',[])
          let member = objData.memberData
          let team = objData.team
          const userComp = rootState.authen.user.company
          let arrBoss:Array<any> = [];
          let parentId = ''
          if(member && team){
            _.forEach(member, (item,key)=> {
              arrBoss[item.boss] = item.boss_team
              firebase.database().ref(`/users/${item.key}`).update({
                team:team,
                modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
              }).then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                  company: userComp,
                  createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  id: item.key,
                  table: 'users',
                  status: 'assignTeam',
                  user: rootState.authen.user.email
                }, {root:true})
              });
            });
            if(Object.keys(arrBoss).length > 0){
              if(Object.keys(arrBoss).length == 1){
                parentId = (member[0] && member[0].boss_team)?member[0].boss_team : ""
                if(state.teamByKey[team] && parentId && team !== parentId){
                  firebase.database().ref(`team/${team}`).update({
                    parent:parentId,
                    updated:format(new Date(), 'YYYY-MM-DD HH:mm')
                  }).then(()=>{
                    firebase.database().ref(`/genorganize`).push({
                        company:rootState.authen.user.company
                    });
                  });
                }
              }else{
                _.forEach(member, (item,key)=> {
                  if(!parentId && arrBoss[item.email]){
                    parentId = item.boss_team
                  }
                });
                if(parentId){
                  if(state.teamByKey[team] && parentId && team !== parentId){
                    firebase.database().ref(`team/${team}`).update({
                      parent:parentId,
                      updated:format(new Date(), 'YYYY-MM-DD HH:mm')
                    }).then(()=>{
                      firebase.database().ref(`/genorganize`).push({
                          company:rootState.authen.user.company
                      });
                    });
                  }
                }
              }
            }
            dispatch('main/removeUser',true,{root:true})
            firebase.database().ref(`/genboss`).push({
              company:userComp
            }).then(function() {
              commit('setPage',1)
              // setTimeout(() => {
              //   let data={...rootState.authen.user,getMember:true}
              //   dispatch('getMember',data)
              // }, 3000)
              commit('setUpdateMember',true)
             dispatch('getMember',rootState.authen.user)
            });
          }
        },
        async getArchiveData({commit,rootState,dispatch,state}:any, user:any){
          commit('setLoadingArchiveTable',true)
          const users:Array<any> = [];
          const memberKey:Array<any> = [];
          state.membersArchive = []
          state.membersArchiveAll = []
          const team = await getTeamByCompany(user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
          await firebase.database().ref().child('users_employee_exit').orderByChild('company').equalTo(`${user.company}`).once('value',async snapshot => {
            snapshot.forEach((arrData):any => {
              const u = arrData.val()
              u.key = arrData.key
              u.value = arrData.val().firstname + " " + arrData.val().lastname
              if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
              if(u.profilepic_small){
                u.pic = u.profilepic_small;
              }else if (u.profilepic_crop){
                u.pic = u.profilepic_crop;
              }else if (u.profilepic){
                u.pic = u.profilepic;
              }else {
                u.pic = "";
              }
              if(u.exitdated){
                u.archiveddate = globalfunc.timeSince(u.exitdated)
                // Add timestamp for proper sorting
                u.archived_timestamp = new Date(u.exitdated).getTime()
              }else if(u.archive_date){
                u.archiveddate = globalfunc.timeSince(u.archive_date)
                // Add timestamp for proper sorting
                u.archived_timestamp = new Date(u.archive_date).getTime()
              }
              u.archive_type=u.archive_type=='other'?'Other':u.archive_type=='terminated'?'Terminated':'Resigned'
              memberKey[u.key] = u
              users.push(u)
            });
            users.push(...state.userArchivedSchedule)
            
            // Add timestamp for all users (including scheduled archives)
            for(var i in users){
              if(users[i].exitdated) {
                users[i].archived_timestamp = new Date(users[i].exitdated).getTime()
              } else if(users[i].archive_date) {
                users[i].archived_timestamp = new Date(users[i].archive_date).getTime()
              }
            }
            for(var i in state.userArchivedSchedule){
              // Add timestamp for scheduled archives
              if(state.userArchivedSchedule[i].exitdated) {
                state.userArchivedSchedule[i].archived_timestamp = new Date(state.userArchivedSchedule[i].exitdated).getTime()
              } else if(state.userArchivedSchedule[i].archive_date) {
                state.userArchivedSchedule[i].archived_timestamp = new Date(state.userArchivedSchedule[i].archive_date).getTime()
              }
              memberKey[state.userArchivedSchedule[i].key]=state.userArchivedSchedule[i]
            }
            
            // Sort by archived_timestamp in descending order (most recent first)
            var _users = _.orderBy(users, ['archived_timestamp'], ['desc'])
            
            commit('setMemberArchiveKey', memberKey)
            commit('setResultsArchive',users)
            commit('setMemberArchive', _users.slice(0, state.size_page))
            commit('setMemberArchiveAll', _users)
            commit('setSortfieldArchive', 'archived_timestamp')
            commit('setSortorderArchive', 'desc')
            commit('setLoadingArchiveTable',false)
            if(state.inputSearchArchive){
              dispatch('searchMembersArchive',state.inputSearchArchive)
            }
          }).catch(error => {
            console.log(error)
          });
        },
        getRisk({commit,dispatch,state,rootState}:any, item:any){  
          const riskData=[]
          firebase.firestore().collection('report_weekly_risk_area_all').where('email','==',item.email).get()
          .then((querySnapshot)=> {
              querySnapshot.forEach(async (doc)=> {
                const data=doc.data()
                let day=format(subDays(data.date,1),'YYYY-MM-DD')
                  if(!riskData[day]) riskData[day]=[]
                  riskData[day].push(data.category)
              });
              commit('setriskCategory',riskData)
            });
          let report_weekly_risk={}
          firebase.firestore().collection('report_weekly_risk_all').where('email','==',item.email).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                  const data=doc.data()
                  let day=format(subDays(data.date,1),'YYYY-MM-DD')
                  report_weekly_risk[day]=data
             
              })
              
                  commit('setRisk',report_weekly_risk)
                
              //console.log("report_weekly_risk",report_weekly_risk)
            })
      },
      getStarPerformer({commit,dispatch,state,rootState}:any, item:any){
          let report_weekly_performer={}
          firebase.firestore().collection('report_weekly_performer').where('email','==',item.email).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                  const data=doc.data()
                  let day=format(subDays(data.date,1),'YYYY-MM-DD')
                  report_weekly_performer[day]=data
              })
              commit('setStarPerformer',report_weekly_performer)
            })
      },
      getHoliday({commit,dispatch,state,rootState}:any, item:any){
          let holiday: Array<any> = [];
          firebase.firestore().collection('holliday').where('companyid','==',rootState.authen.user.company).get().then((querySnapshot)=>{
              querySnapshot.forEach((doc) => {
                  const data=doc.data()
                  holiday.push(data)
              })
              commit('setHoliday',holiday)
            })
      },
      async getDailyStatus({commit,dispatch,state,rootState}:any, item:any){
        commit('setLoadingLoadMoreData',true)
        let _data={}
        let currentDate=state.date
        let last30day=format(subDays(state.date,30),"YYYY-MM-DD")
        state.date=format(subDays(state.date,31),"YYYY-MM-DD")

        firebase.firestore().collection('users_questions').where("users","==",item.email).where('date',">=",`${last30day}`).where('quest_id','==','-Kgs61AHOnpJ3rfyQr6t').get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()

                // if(data.quest_id=="-Kgs61AHOnpJ3rfyQr6t"){
                    if(_data[data.date]){
                        _data[data.date]=""
                      }
                        if(data.answer==0||data.answer==1){
                            _data[data.date]="green"
                          }else if(data.answer==2){
                            _data[data.date]="yellow"
                          }else if(data.answer==3||data.answer==4){
                            _data[data.date]="red"
                          }
                          else{
                            _data[data.date]="gray"
                          }
                    
                // }
            })
        for(var i=30;i>=0;i--){
            let temp_data={}
            const date=format(subDays(currentDate,i),"YYYY-MM-DD")
            const daytext=format(new Date(date), "ddd");
            var _holiday = _.find(state.holiday, function(value){
                return value != null && value.date == date;
              });
            var starPerformer=state.starPerformer[date]?"S":""
            var risk=state.risk[date]?state.risk[date].risk_level+"R":""
            let risk_due_txt = state.risk[date]?state.risk[date].risk_due:"Happiness"
            let riskCategoryTxt=""
            if(state.riskCategory[date]){
              let conut=0
              for(var j in state.riskCategory[date]){
                conut+=1
                if(state.riskCategory[date].length==conut){
                  riskCategoryTxt=riskCategoryTxt+state.riskCategory[date][j]
                }else{
                  riskCategoryTxt=riskCategoryTxt+state.riskCategory[date][j]+", "
                }
                
              }
            }
            // console.log("date",date)
            // console.log("riskCategoryTxt",riskCategoryTxt)
            var highlight:any=false
            var highlight_txt:any=false
            if(starPerformer&&risk)
            {
                highlight=starPerformer+"&"+(risk=="1R"?"R":risk)
                riskCategoryTxt=riskCategoryTxt?riskCategoryTxt:'Happiness'
                highlight_txt= `Star Performer<br><br>${risk_due_txt}`
                // if(highlight=="S&3R"){
                //     highlight_txt= `Star Performer with Problem Areas: Wellness, Personal Growth`
                // }else if(highlight=="S&2R"){
                //     highlight_txt= `Star Performer with Problem Areas: Wellness, Personal Growth`
                // }else if(highlight=="S&R"){
                //     highlight_txt= `Star Performer with Problem Areas: Wellness, Personal Growth`
                // }
            }else if(starPerformer){
                highlight=starPerformer
                highlight_txt=`Star Performer`
            }else if(risk){
                highlight=risk=="1R"?"R":risk
                riskCategoryTxt=riskCategoryTxt?riskCategoryTxt:'Happiness'
                highlight_txt= `${risk_due_txt}`
               
            }
           
            

              if(!_holiday){
                
                temp_data={
                    day: daytext,
                    date: date,
                    status: daytext=="Sun"||daytext=="Sat"?"none":_data[date],
                    highlight: highlight,
                    highlightContent: highlight_txt,
                  }
              }else{
                temp_data={
                    day: daytext,
                    date: date,
                    status: daytext=="Sun"||daytext=="Sat"?"none":"holiday",
                    highlight: highlight,
                    highlightContent: highlight_txt,
                  }
              }
              state.riskData.push(temp_data)
              state.riskData=_.sortBy(state.riskData, [
                function (o) {
                  return new Date(o.date);
                },
              ]);
             }
        })
        commit('setLoadingLoadMoreData',false)
      },
      async getPowerData({commit,dispatch,state,rootState}:any, item:any){
        commit('setPowerData',[])
        let power: Array<any> = [];
        if(item.email){
          const emailKey = item.email.replace(/\./g, '||')
          var userData = await getByUser(item.email)//(await firebase.database().ref(`/users/${emailKey}`).once('value')).val()
        }
        power.push(
          {
              label: "Empathy",
              rating: userData.power_tag12?(userData.power_tag12.ps_empathy && userData.power_tag12.ps_empathy.rating > 0 && userData.power_tag12.ps_empathy.answer > 0 ?(userData.power_tag12.ps_empathy.rating / userData.power_tag12.ps_empathy.answer).toFixed(1):'—'):'—',
              value: userData.power_tag?(userData.power_tag.ps_empathy?userData.power_tag.ps_empathy.point:0):0,
              maxValue: userData.power_tag?(userData.power_tag.ps_empathy?userData.power_tag.ps_empathy.point_total:0):0,
              icon: "ic_empathy",
              percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_empathy?userData.power_tag12.ps_empathy.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_empathy?userData.power_tag12.ps_empathy.point_total:0):0)),
            },
            {
              label: "Self-awareness",
              rating: userData.power_tag12?(userData.power_tag12.ps_self_awareness && userData.power_tag12.ps_self_awareness.rating > 0 && userData.power_tag12.ps_self_awareness.answer > 0 ?(userData.power_tag12.ps_self_awareness.rating / userData.power_tag12.ps_self_awareness.answer).toFixed(1):'-'):'-',
              value: userData.power_tag?(userData.power_tag.ps_self_awareness?userData.power_tag.ps_self_awareness.point:0):0,
              maxValue: userData.power_tag?(userData.power_tag.ps_self_awareness?userData.power_tag.ps_self_awareness.point_total:0):0,
              icon: "ic_selfawareness",
              percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_self_awareness?userData.power_tag12.ps_self_awareness.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_self_awareness?userData.power_tag12.ps_self_awareness.point_total:0):0)),
            },
            {
              label: "Critical Thinking",
              rating: userData.power_tag12?(userData.power_tag12.ps_critical_thinking && userData.power_tag12.ps_critical_thinking.rating > 0 && userData.power_tag12.ps_critical_thinking.answer > 0 ?(userData.power_tag12.ps_critical_thinking.rating / userData.power_tag12.ps_critical_thinking.answer).toFixed(1):'—'):'—',
              value:userData.power_tag?(userData.power_tag.ps_critical_thinking?userData.power_tag.ps_critical_thinking.point:0):0,
              maxValue:userData.power_tag?(userData.power_tag.ps_critical_thinking?userData.power_tag.ps_critical_thinking.point_total:0):0,
              icon: "ic_criticalthinking",
              percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_critical_thinking?userData.power_tag12.ps_critical_thinking.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_critical_thinking?userData.power_tag12.ps_critical_thinking.point_total:0):0)),
            },
            {
              label: "Leadership",
              rating: userData.power_tag12?(userData.power_tag12.ps_leadership && userData.power_tag12.ps_leadership.rating > 0 && userData.power_tag12.ps_leadership.answer > 0 ?(userData.power_tag12.ps_leadership.rating / userData.power_tag12.ps_leadership.answer).toFixed(1):'—'):'—',
              value: userData.power_tag?(userData.power_tag.ps_leadership?userData.power_tag.ps_leadership.point:0):0,
              maxValue: userData.power_tag?(userData.power_tag.ps_leadership?userData.power_tag.ps_leadership.point_total:0):0,
              icon: "ic_leadership",
              percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_leadership?userData.power_tag12.ps_leadership.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_leadership?userData.power_tag12.ps_leadership.point_total:0):0)),
            },
            {
              label: "Initiative-making",
              rating: userData.power_tag12?(userData.power_tag12.ps_initiative_making && userData.power_tag12.ps_initiative_making.rating > 0 && userData.power_tag12.ps_initiative_making.answer > 0 ?(userData.power_tag12.ps_initiative_making.rating / userData.power_tag12.ps_initiative_making.answer).toFixed(1):'—'):'—',
              value: userData.power_tag?(userData.power_tag.ps_initiative_making?userData.power_tag.ps_initiative_making.point:0):0,
              maxValue:userData.power_tag?(userData.power_tag.ps_initiative_making?userData.power_tag.ps_initiative_making.point_total:0):0,
              icon: "ic_initiative",
              percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_initiative_making?userData.power_tag12.ps_initiative_making.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_initiative_making?userData.power_tag12.ps_initiative_making.point_total:0):0)),
            },
            {
              label: "Optimism",
              rating: userData.power_tag12?(userData.power_tag12.ps_optimism && userData.power_tag12.ps_optimism.rating > 0 && userData.power_tag12.ps_optimism.answer > 0 ?(userData.power_tag12.ps_optimism.rating / userData.power_tag12.ps_optimism.answer).toFixed(1):'—'):'-',
              value: userData.power_tag?(userData.power_tag.ps_optimism?userData.power_tag.ps_optimism.point:0):0,
              maxValue:userData.power_tag?( userData.power_tag.ps_optimism?userData.power_tag.ps_optimism.point_total:0):0,
              icon: "ic_optimism",
              percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_optimism?userData.power_tag12.ps_optimism.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_optimism?(userData.power_tag12.ps_optimism.point_total?userData.power_tag12.ps_optimism.point_total:0):0):0)),
            },
      )
          power.map(value=>{
              if(value.percent==true){
                  value.percent=0
              }
          })
        var data = _.orderBy(power, ['percent','value'], ['desc', 'desc']);
        commit('setPowerData',data)
        
      },
      clearDate({commit,dispatch,state,rootState}:any, item:any){
        state.date=format(new Date(),"YYYY-MM-DD"),
        state.riskData=[]
        let power: Array<any> = [];
        power.push(
          {
              label: "Empathy",
              value: 0,
              maxValue:100,
              icon: "ic_empathy",
          },
            {
              label: "Self-awareness",
              value: 0,
              maxValue:100,
              icon: "ic_selfawareness",
             
            },
            {
              label: "Critical Thinking",
              value:0,
              maxValue:100,
              icon: "ic_criticalthinking",
              
            },
            {
              label: "Leadership",
              value: 0,
              maxValue: 100,
              icon: "ic_leadership",
            },
            {
              label: "Initiative-making",
              value: 0,
              maxValue:100,
              icon: "ic_initiative",
            },
            {
              label: "Optimism",
              value: 0,
              maxValue:100,
              icon: "ic_optimism",
              
            },
      )
        commit('setPowerData',power)
         
      },
      getTimezone({ commit, rootState, state, dispatch }: any, value: any){
        let timezone=countriesAndTimezone.getAllTimezones()
        let countries=countriesAndTimezone.getAllCountries()
        let optionsTimezone:Array<any>=[]
        let optTimezone:Array<any>=[]
        let locationOption:Array<any>=[]
        let _country:any=""
        let time_zone:number=0
        // console.log("timezone",timezone)
        // for(let value in timezone){
        //   optionsTimezone.push( { lable:value,value: value,utcOffsetStr:timezone[value].utcOffsetStr})
        // }
        for(let value in timezone){
            if(timezone[value].countries.length>0){
              optionsTimezone.push(timezone[value])
            }
        }
        const _optionsTimezone=_.groupBy(optionsTimezone, function (b) { return b.utcOffsetStr})
        for(let value in _optionsTimezone){
          _optionsTimezone[value].map((v,index)=>{
            if(index<3){
              if(_country==""){
                _country=v.name.split('/')[1].replace('_'," ");
              }else{
                _country=_country+", "+v.name.split('/')[1].replace('_'," ")
              }
            }
            time_zone=Number(value.replace(':','.'))
           // time_zone=(+value == Math.floor(+value))?parseInt(value):parseFloat(value)
    
          })
          optTimezone.push({lable: value,country:_country,utcOffsetStr:value+" GMT",sort:time_zone})
          _country=""
        }
        
        
        for(let value in countries){
            locationOption.push( { lable: value,value: countries[value].name})
        }
        locationOption=_.sortBy(locationOption, [
            function(o) {
              return o.value;
            }
          ]);
          optTimezone=_.sortBy(optTimezone, [
            function(o) {
              return o.sort;
            }
          ]);
          // console.log("locationOption",locationOption)
        commit('setTimeZoneOption',optTimezone)
        commit('setLocationOption',locationOption)
        commit('setTimezone',timezone)
       
      },
      async getRecognition({commit, dispatch, state} : any,user : any) {
        const superFeedback={}
        let recognitionValue: any = [{value: 'All', label: 'All'}]
        const companyData = await getCompany(user.company)
        if (companyData.hashtag) {
            for (var value in companyData.hashtag) {
                recognitionValue.push({value: value, label: companyData.hashtag[value].name});
                Object.assign(state.tag,{[companyData.hashtag[value].name]: 0});
            }
            commit('setRecognitionValue', recognitionValue)
        }
      },
      async getHerepoint({commit, dispatch, state,rootState} : any,user : any) {
        let data: any = []
      
        const tag=state.tag
        let date = format(addDays(new Date(), -180), 'YYYY-MM-DD')
        let recognition = {}
        let alignment={}
        let hashtags={}
        const alluser=rootState.main.allUser
        const team=rootState.main.allTeam
        await firebase.firestore().collection('here_point').where('company', '==', user.company).where('date', '>', date).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                const u = doc.data()
                u.id = doc.id
                u.dateFormatted = format(u.date, 'MMM DD, YYYY')
                
                if (u.statusrow == 'sendcoin' || u.statusrow == 'sendgem') {
                    if(u.core_value_ai){
                        let count=0
                        for(const i in u.core_value_ai){
                            if(u.core_value_ai[i].rating>4){
                                u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                count++
                            }else{
                                if(u.hashtag_prev){
                                    u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                }
                            }
                            
                        }
                    }
                    const _emailKey=u.send_to_email.replace(/\./g, '||')
                    u.profilepic=alluser[_emailKey]&&alluser[_emailKey].profilepic?alluser[_emailKey].profilepic:''
                    u.shortname=alluser[_emailKey]?alluser[_emailKey].firstname.charAt(0) + alluser[_emailKey].lastname.charAt(0):''
                    state.dataAll.push(u)
                    let emailKey=u.sender_email.replace(/\./g, '||')

                    if(alluser[emailKey]){
                        if (! recognition[u.sender_email]) {
                            recognition[u.sender_email] = {
                                key:u.id,
                                email: u.sender_email,
                                // email_to:u.send_to_email,
                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                team_id:alluser[emailKey].team,
                                impactRating:alluser[emailKey].impact_rating,
                                tag:u.hashtag,
                                date:u.date,
                                given: 0,
                                received: 0,
                                ratio: '',
                                orderGiven:'',
                                orderReceived:'',
                                orderRatio:'',
                                hashtag:{},
                                order_Given:0,
                                order_Received:0,
                                order_Ratio:0,
                                
                            }
                        }
                      recognition[u.sender_email].given ++
                      if(u.hashtag){
                        for(const i in u.hashtag){
                        if(!hashtags[u.sender_email]){
                          hashtags[u.sender_email]={All:0,...tag}
                        }         
                        hashtags[u.sender_email].All++
                        hashtags[u.sender_email][u.hashtag[i]]++
                        }
                      }
                    }

                    emailKey=u.send_to_email.replace(/\./g, '||')
                    if(alluser[emailKey]){
                        if (! recognition[u.send_to_email]) {
                        const emailKey=u.send_to_email.replace(/\./g, '||')
                        recognition[u.send_to_email] = {
                            key:u.id,
                            email: u.send_to_email,
                            // email_to:u.send_to_email,
                            profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                            firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                            lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                            shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                            teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                            team_id:alluser[emailKey].team,
                            impactRating:alluser[emailKey].impact_rating,
                            tag:u.hashtag,
                            date:u.date,
                            given: 0,
                            received: 0,
                            ratio: '',
                            sortRatio:0,
                            orderGiven:'',
                            orderReceived:'',
                            orderRatio:'',
                            hashtag:{},
                            order_Given:0,
                            order_Received:0,
                            order_Ratio:0,
                        }
                        }
                        recognition[u.send_to_email].received ++
                        if(u.hashtag){
                          for(const i in u.hashtag){
                          if(!hashtags[u.send_to_email]){
                            hashtags[u.send_to_email]={All:0,...tag}
                          }         
                          hashtags[u.send_to_email].All++
                          hashtags[u.send_to_email][u.hashtag[i]]++
                          }
                        }
                    }
                    if(u.core_value_ai){
                        emailKey=u.sender_email.replace(/\./g, '||')
                        if(alluser[emailKey]){
                            if(!alignment[u.sender_email]){
                                alignment[u.sender_email]={
                                    email: u.sender_email,
                                    profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                    firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                    lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                    shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                    teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                    team_id:alluser[emailKey].team,
                                    impactRating:alluser[emailKey].impact_rating,
                                    tag:u.hashtag,
                                    effortGiven:0,
                                    totalGiven:0,
                                    effortReceived:0,
                                    totalReceived:0,
                                    alignmentGiven:0,
                                    alignmentReceived:0,
                                    alignmentRatio:0}
                            }
                            

                        }
                        emailKey=u.send_to_email.replace(/\./g, '||')
                        if(alluser[emailKey]){
                            if(!alignment[u.send_to_email]){
                                //const emailKey=u.send_to_email.replace(/\./g, '||')
                                alignment[u.send_to_email]={
                                    email: u.send_to_email,
                                    profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                    firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                    lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                    shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                    teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                    team_id:alluser[emailKey].team,
                                    effortGiven:0,totalGiven:0,effortReceived:0,totalReceived:0,
                                    impactRating:alluser[emailKey].impact_rating,
                                    alignmentGiven:0,
                                    alignmentReceived:0,
                                    alignmentRatio:0}
                            }
                            
                        }
                        for(const i in u.core_value_ai){
                            if(u.core_value_ai[i].rating){
                               
                                emailKey=u.sender_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
                                    alignment[u.sender_email].totalGiven++
                                }
                                emailKey=u.send_to_email.replace(/\./g, '||')
                                
                                if(alluser[emailKey]){
                                    alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
                                    alignment[u.send_to_email].totalReceived++
                                }
                            }
                         
                        }
                        
                    }
                }
            });
            for (const i in recognition) {
                
                if (recognition[i].received > 0) {
                    recognition[i].sortRatio=(recognition[i].given / recognition[i].received)
                    recognition[i].ratio = (recognition[i].given / recognition[i].received).toFixed(1)
                } else {
                    recognition[i].sortRatio=recognition[i].given
                    recognition[i].ratio = recognition[i].given.toFixed() + '*'
                }
                
            }
            for(const i in alignment){
                if(alignment[i].totalGiven>0){
                    alignment[i].alignmentGiven=isNaN(alignment[i].effortGiven/alignment[i].totalGiven)?0: (alignment[i].effortGiven/alignment[i].totalGiven).toFixed(1)
                }
                if(alignment[i].totalReceived>0){
                    alignment[i].alignmentReceived= isNaN(alignment[i].effortReceived/alignment[i].totalReceived)?0:(alignment[i].effortReceived/alignment[i].totalReceived).toFixed(1)
                }
                alignment[i].alignmentRatio= isNaN((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived))?0:((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived)).toFixed(1)
            }

            for(const emailKey in alluser){
              if(!recognition[alluser[emailKey].email]){
                recognition[alluser[emailKey].email] = {
                  key:emailKey,
                  email: alluser[emailKey].email,
                  profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                  firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                  lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                  shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                  teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                  team_id:alluser[emailKey].team,
                  impactRating:alluser[emailKey].impact_rating,
                  given: 0,
                  received: 0,
                  ratio: 0,
                  sortRatio:0,
                  orderGiven:'',
                  orderReceived:'',
                  orderRatio:'',
                  hashtag:{},
                  order_Given:0,
                  order_Received:0,
                  order_Ratio:0,
              }
              }

              if(!alignment[alluser[emailKey].email]){
                alignment[alluser[emailKey].email]={
                    email: emailKey,
                    profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                    firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                    lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                    shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                    teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                    team_id:alluser[emailKey].team,
                    impactRating:alluser[emailKey].impact_rating,
                    effortGiven:0,
                    totalGiven:0,
                    effortReceived:0,
                    totalReceived:0,
                    alignmentGiven:0,
                    alignmentReceived:0,
                    alignmentRatio:0}
              }

            }
            const given = _.orderBy(recognition, ['given'], ['desc'])
            const received = _.orderBy(recognition, ['received'], ['desc'])
            const sortRatio = _.orderBy(recognition, ['sortRatio'], ['desc'])
            let count=0
            let given_order=0
            for(const i in given){
              if(given_order!=recognition[given[i].email].given){
                given_order=recognition[given[i].email].given
                count++
                state.last_rank_given=count
              }
                recognition[given[i].email].order_Given=count
              if(count%10==1){
                recognition[given[i].email].orderGiven=count+'st'
              }else if(count%10==2){
                recognition[given[i].email].orderGiven=count+'nd'
              }else if(count%10==3){
                recognition[given[i].email].orderGiven=count+'rd'
              }else{
                recognition[given[i].email].orderGiven=count+'th'
              }
            }
            let count_received=0
            let received_order=0
            for(const i in received){
              if(received_order!=recognition[received[i].email].received){
                received_order=recognition[received[i].email].received
                count_received++
                state.last_rank_received=count_received
              }
              recognition[received[i].email].order_Received=count_received
              if(count_received%10==1){
                recognition[received[i].email].orderReceived=count_received+'st'
              }else if(count_received%10==2){
                recognition[received[i].email].orderReceived=count_received+'nd'
              }else if(count_received%10==3){
                recognition[ received[i].email].orderReceived=count_received+'rd'
              }else{
                recognition[ received[i].email].orderReceived=count_received+'th'
              }

              
            }
            let count_ratio=0
            let ratio_order=0
            for(const i in sortRatio){
              if(ratio_order!=recognition[sortRatio[i].email].sortRatio){
                ratio_order=recognition[sortRatio[i].email].sortRatio
                count_ratio++
                state.last_rank_ratio=count_ratio
              }
              
              recognition[sortRatio[i].email].order_Ratio=count_ratio
              if(count_ratio%10==1){
                recognition[sortRatio[i].email].orderRatio=count_ratio+'st'
              }else if(count_ratio%10==2){
                recognition[sortRatio[i].email].orderRatio=count_ratio+'nd'
              }else if(count_ratio%10==3){
                recognition[sortRatio[i].email].orderRatio=count_ratio+'rd'
              }else{
                recognition[sortRatio[i].email].orderRatio=count_ratio+'th'
              }
            }

            commit('setRecognition', recognition)
            commit('setAlignment', alignment)
            commit('sethashtag',hashtags)

        });
      },
      async filtersReconition({commit, dispatch, state,rootState} : any,value : any){
        console.log('filtersReconition',value)
      //   let recognitionAll:any=[]
      //   let alignmentAll:any=[]
      //   let recognition = {}
      //   let alignment={}
      //   recognitionAll=state.recognitionAll
      //   alignmentAll=state.alignmentAll
      //   const alluser=rootState.main.allUser
      //   const team=rootState.main.allTeam
      //  for(const data in state.dataAll){
      //       const u = state.dataAll[data]
      //       if(value=='All'){
      //           u.dateFormatted = format(u.date, 'MMM DD, YYYY')
      //           if (u.statusrow == 'sendcoin' || u.statusrow == 'sendgem') {
                 
      //               if(u.core_value_ai){
      //                   let count=0
      //                   for(const i in u.core_value_ai){
      //                       if(u.core_value_ai[i].rating>4){
      //                           u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
      //                           count++
      //                       }else{
      //                           if(u.hashtag_prev){
      //                               u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
      //                           }
      //                       }
                            
      //                   }
      //               }
      //               let emailKey=u.sender_email.replace(/\./g, '||')
      //               if(alluser[emailKey]){
      //                   if (! recognition[u.sender_email]) {
      //                       recognition[u.sender_email] = {
      //                           key:u.id,
      //                           email: u.sender_email,
      //                           profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
      //                           firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
      //                           lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
      //                           shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
      //                           teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
      //                           team_id:alluser[emailKey].team,
      //                           impactRating:alluser[emailKey].impact_rating,
      //                           tag:u.hashtag,
      //                           date:u.date,
      //                           given: 0,
      //                           received: 0,
      //                           ratio: '',
      //                           sortRatio:0,
      //                           orderGiven:'',
      //                           orderReceived:'',
      //                           orderRatio:'',
      //                           hashtag:{},
      //                           order_Given:0,
      //                           order_Received:0,
      //                           order_Ratio:0,
      //                       }
      //                   }
      //               recognition[u.sender_email].given ++

      //               }
      //               emailKey=u.send_to_email.replace(/\./g, '||')
      //               if(alluser[emailKey]){
      //                   if (! recognition[u.send_to_email]) {
      //                   const emailKey=u.send_to_email.replace(/\./g, '||')
      //                   recognition[u.send_to_email] = {
      //                       key:u.id,
      //                       email: u.send_to_email,
      //                       profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
      //                       firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
      //                       lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
      //                       shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
      //                       teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
      //                       team_id:alluser[emailKey].team,
      //                       impactRating:alluser[emailKey].impact_rating,
      //                       tag:u.hashtag,
      //                       date:u.date,
      //                       given: 0,
      //                       received: 0,
      //                       ratio: '',
      //                       sortRatio:0,
      //                       orderGiven:'',
      //                       orderReceived:'',
      //                       orderRatio:'',
      //                       hashtag:{},
      //                       order_Given:0,
      //                       order_Received:0,
      //                       order_Ratio:0,
      //                   }
      //                   }
      //                   recognition[u.send_to_email].received ++
      //               }
      //               if(u.core_value_ai){
      //                   emailKey=u.sender_email.replace(/\./g, '||')
      //                   if(alluser[emailKey]){
      //                       if(!alignment[u.sender_email]){
      //                           alignment[u.sender_email]={
      //                               email: u.sender_email,
      //                               profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
      //                               firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
      //                               lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
      //                               shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
      //                               teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
      //                               team_id:alluser[emailKey].team,
      //                               impactRating:alluser[emailKey].impact_rating,
      //                               tag:u.hashtag,
      //                               effortGiven:0,
      //                               totalGiven:0,
      //                               effortReceived:0,
      //                               totalReceived:0,
      //                               alignmentGiven:0,
      //                               alignmentReceived:0,
      //                               alignmentRatio:0
      //                               }
      //                       }
                            

      //                   }
      //                   emailKey=u.send_to_email.replace(/\./g, '||')
      //                   if(alluser[emailKey]){
      //                       if(!alignment[u.send_to_email]){
      //                           //const emailKey=u.send_to_email.replace(/\./g, '||')
      //                           alignment[u.send_to_email]={
      //                               email: u.send_to_email,
      //                               profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
      //                               firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
      //                               lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
      //                               shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
      //                               teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
      //                               effortGiven:0,totalGiven:0,effortReceived:0,totalReceived:0,
      //                               team_id:alluser[emailKey].team,
      //                               impactRating:alluser[emailKey].impact_rating,
      //                               alignmentGiven:0,
      //                               alignmentReceived:0,
      //                               alignmentRatio:0}
      //                       }
                            
      //                   }
      //                   for(const i in u.core_value_ai){
      //                       if(u.core_value_ai[i].rating){
                               
      //                           emailKey=u.sender_email.replace(/\./g, '||')
      //                           if(alluser[emailKey]){
      //                               alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
      //                               alignment[u.sender_email].totalGiven++
      //                           }
      //                           emailKey=u.send_to_email.replace(/\./g, '||')
                                
      //                           if(alluser[emailKey]){
      //                               alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
      //                               alignment[u.send_to_email].totalReceived++
      //                           }
      //                       }
                         
      //                   }
                        
      //               }
      //           }
      //       }else{
      //           const findHashtag=_.find(u.hashtag, function(o) { return o == value; });
      //            if(findHashtag){
      //               u.dateFormatted = format(u.date, 'MMM DD, YYYY')
      //           if (u.statusrow == 'sendcoin' || u.statusrow == 'sendgem') {
                   
      //               if(u.core_value_ai){
      //                   let count=0
      //                   for(const i in u.core_value_ai){
      //                       if(u.core_value_ai[i].rating>4){
      //                           u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
      //                           count++
      //                       }else{
      //                           if(u.hashtag_prev){
      //                               u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
      //                           }
      //                       }
                            
      //                   }
      //               }
      //               let emailKey=u.sender_email.replace(/\./g, '||')
      //               if(alluser[emailKey]){
      //                   if (! recognition[u.sender_email]) {
      //                       recognition[u.sender_email] = {
      //                           key:u.id,
      //                           email: u.sender_email,
      //                           profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
      //                           firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
      //                           lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
      //                           shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
      //                           teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
      //                           team_id:alluser[emailKey].team,
      //                           impactRating:alluser[emailKey].impact_rating,
      //                           tag:u.hashtag,
      //                           date:u.date,
      //                           given: 0,
      //                           received: 0,
      //                           ratio: '',
      //                           sortRatio:0,
      //                           orderGiven:'',
      //                           orderReceived:'',
      //                           orderRatio:'',
      //                           hashtag:{},
      //                           order_Given:0,
      //                           order_Received:0,
      //                           order_Ratio:0,
      //                       }
      //                   }
      //               recognition[u.sender_email].given ++

      //               }
      //               emailKey=u.send_to_email.replace(/\./g, '||')
      //               if(alluser[emailKey]){
      //                   if (! recognition[u.send_to_email]) {
      //                   const emailKey=u.send_to_email.replace(/\./g, '||')
      //                   recognition[u.send_to_email] = {
      //                       key:u.id,
      //                       email: u.send_to_email,
      //                       profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
      //                       firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
      //                       lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
      //                       shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
      //                       teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
      //                       team_id:alluser[emailKey].team,
      //                       impactRating:alluser[emailKey].impact_rating,
      //                       tag:u.hashtag,
      //                       date:u.date,
      //                       given: 0,
      //                       received: 0,
      //                       ratio: '',
      //                       sortRatio:0,
      //                       orderGiven:'',
      //                       orderReceived:'',
      //                       orderRatio:'',
      //                       hashtag:{},
      //                       order_Given:0,
      //                       order_Received:0,
      //                       order_Ratio:0,
      //                   }
      //                   }
      //                   recognition[u.send_to_email].received ++
      //               }
      //               if(u.core_value_ai){
      //                   emailKey=u.sender_email.replace(/\./g, '||')
      //                   if(alluser[emailKey]){
      //                       if(!alignment[u.sender_email]){
      //                           alignment[u.sender_email]={
      //                               email: u.sender_email,
      //                               profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
      //                               firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
      //                               lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
      //                               shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
      //                               teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
      //                               team_id:alluser[emailKey].team,
      //                               impactRating:alluser[emailKey].impact_rating,
      //                               tag:u.hashtag,
      //                               effortGiven:0,
      //                               totalGiven:0,
      //                               effortReceived:0,
      //                               totalReceived:0,
      //                               alignmentGiven:0,
      //                               alignmentReceived:0,
      //                               alignmentRatio:0}
      //                       }
                            

      //                   }
      //                   emailKey=u.send_to_email.replace(/\./g, '||')
      //                   if(alluser[emailKey]){
      //                       if(!alignment[u.send_to_email]){
      //                           //const emailKey=u.send_to_email.replace(/\./g, '||')
      //                           alignment[u.send_to_email]={
      //                               email: u.send_to_email,
      //                               profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
      //                               firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
      //                               lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
      //                               shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
      //                               teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
      //                               team_id:alluser[emailKey].team,
      //                               effortGiven:0,
      //                               totalGiven:0,
      //                               effortReceived:0,
      //                               totalReceived:0,
      //                               impactRating:alluser[emailKey].impact_rating,
      //                               alignmentGiven:0,
      //                               alignmentReceived:0,
      //                               alignmentRatio:0}
      //                       }
                            
      //                   }
      //                   for(const i in u.core_value_ai){
      //                       if(u.core_value_ai[i].rating){
                               
      //                           emailKey=u.sender_email.replace(/\./g, '||')
      //                           if(alluser[emailKey]){
      //                               alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
      //                               alignment[u.sender_email].totalGiven++
      //                           }
      //                           emailKey=u.send_to_email.replace(/\./g, '||')
                                
      //                           if(alluser[emailKey]){
      //                               alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
      //                               alignment[u.send_to_email].totalReceived++
      //                           }
      //                       }
                         
      //                   }
                        
      //               }
      //           }

      //           }

      //       }
      //   }

      //   for (const i in recognition) {
      //       if (recognition[i].received > 0) {
      //           recognition[i].sortRatio=(recognition[i].given / recognition[i].received)
      //           recognition[i].ratio = (recognition[i].given / recognition[i].received).toFixed(1)
      //       } else {
      //           recognition[i].sortRatio=recognition[i].given
      //           recognition[i].ratio = recognition[i].given.toFixed() + '*'
      //       }
            
      //   }
      //   for(const i in alignment){
      //       if(alignment[i].totalGiven>0){
      //           alignment[i].alignmentGiven=isNaN(alignment[i].effortGiven/alignment[i].totalGiven)?0: (alignment[i].effortGiven/alignment[i].totalGiven).toFixed(1)
      //       }
      //       if(alignment[i].totalReceived>0){
      //           alignment[i].alignmentReceived= isNaN(alignment[i].effortReceived/alignment[i].totalReceived)?0:(alignment[i].effortReceived/alignment[i].totalReceived).toFixed(1)
      //       }
      //       alignment[i].alignmentRatio= isNaN((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived))?0:((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived)).toFixed(1)
      //   }

      //   for(const emailKey in alluser){
      //     if(!recognition[alluser[emailKey].email]){
      //       recognition[alluser[emailKey].email] = {
      //         key:emailKey,
      //         email: alluser[emailKey].email,
      //         profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
      //         firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
      //         lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
      //         shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
      //         teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
      //         team_id:alluser[emailKey].team,
      //         impactRating:alluser[emailKey].impact_rating,
      //         given: 0,
      //         received: 0,
      //         ratio: 0,
      //         sortRatio:0,
      //         orderGiven:'',
      //         orderReceived:'',
      //         orderRatio:'',
      //         hashtag:{},
      //         order_Given:0,
      //         order_Received:0,
      //         order_Ratio:0,
      //     }
      //     }
      //     if(!alignment[alluser[emailKey].email]){
            
      //       alignment[alluser[emailKey].email]={
      //           email: alluser[emailKey].email,
      //           profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
      //           firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
      //           lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
      //           shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
      //           teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
      //           team_id:alluser[emailKey].team,
      //           impactRating:alluser[emailKey].impact_rating,
      //           effortGiven:0,
      //           totalGiven:0,
      //           effortReceived:0,
      //           totalReceived:0,
      //           alignmentGiven:0,
      //           alignmentReceived:0,
      //           alignmentRatio:0}
      //     }

      //   }
      //       const given = _.orderBy(recognition, ['given'], ['desc'])
      //       const received = _.orderBy(recognition, ['received'], ['desc'])
      //       const sortRatio = _.orderBy(recognition, ['sortRatio'], ['desc'])
      //       let count=0
      //       let given_order=0
      //       for(const i in given){
      //         if(given_order!=recognition[given[i].email].given){
      //           given_order=recognition[given[i].email].given
      //           count++
      //           state.last_rank_given=count
      //         }
      //         recognition[given[i].email].order_Given=count
      //         if(count%10==1){
      //           recognition[given[i].email].orderGiven=count+'st'
      //         }else if(count%10==2){
      //           recognition[given[i].email].orderGiven=count+'nd'
      //         }else if(count%10==3){
      //           recognition[given[i].email].orderGiven=count+'rd'
      //         }else{
      //           recognition[given[i].email].orderGiven=count+'th'
      //         }
      //       }
      //       let count_received=0
      //       let received_order=0
      //       for(const i in received){
      //         if(received_order!=recognition[received[i].email].received){
      //           received_order=recognition[received[i].email].received
      //           count_received++
      //           state.last_rank_received=count_received
      //         }
      //         recognition[received[i].email].order_Received=count_received
      //         if(count_received%10==1){
      //           recognition[received[i].email].orderReceived=count_received+'st'
      //         }else if(count_received%10==2){
      //           recognition[received[i].email].orderReceived=count_received+'nd'
      //         }else if(count_received%10==3){
      //           recognition[ received[i].email].orderReceived=count_received+'rd'
      //         }else{
      //           recognition[received[i].email].orderReceived=count_received+'th'
      //         }
              
      //       }
      //       let count_ratio=0
      //       let ratio_order=0
      //       for(const i in sortRatio){
      //         if(ratio_order!=recognition[sortRatio[i].email].sortRatio){
      //           ratio_order=recognition[sortRatio[i].email].sortRatio
      //           count_ratio++
      //           state.last_rank_ratio=count_ratio
      //         }
      //         recognition[received[i].email].order_Ratio=count_ratio
      //         if(count_ratio%10==1){
      //           recognition[sortRatio[i].email].orderRatio=count_ratio+'st'
      //         }else if(count_ratio%10==2){
      //           recognition[sortRatio[i].email].orderRatio=count_ratio+'nd'
      //         }else if(count_ratio%10==3){
      //           recognition[sortRatio[i].email].orderRatio=count_ratio+'rd'
      //         }else{
      //           recognition[sortRatio[i].email].orderRatio=count_ratio+'th'
      //         }
      //       }
            if(value=="All"){
              value='all'
            }
            const recognition =state.recognitionAll[value]
            commit('setRecognition', recognition)
      //       commit('setAlignment', alignment)

      },
      async getDataHerepoint({commit, dispatch, state,rootState} : any,user : any) {
        var axios = require('axios');
          var data = JSON.stringify({
            "company": rootState.authen.user.company,
            "users": user
          });
          const config = {
            method: 'post',
            url: 'https://api-node.happily.ai/leaderboard/herepoint',
            headers: {
              'Content-Type': 'application/json'
            },
            data : data
          };
         axios(config)
          .then(response => {
              const data = response.data
              const hashtags={}
                // console.log('getDataHerepoint',data)
              for(const i in data){
                if(i=='all'){
                  hashtags['All']=data[i].count_hashtag
                }else{
                  hashtags[i]=data[i].count_hashtag
                }
                
              }
              commit('setRecognitionAll', data)
              commit('setRecognition', data['all'])
              commit('sethashtag',hashtags)
            
          })
          .catch(err => {
            console.log(err)
          })

      }
      // deleteEmptyTeam({ commit, rootState, state, dispatch }: any, value: any){
      //   value.map(v=>{

      //   firebase.database().ref('team').child(v.key).remove().then(() => {
      //       console.log("Document successfully deleted!");
      //   }).catch((error) => {
      //       console.error("Error removing document: ", error);
      //   });
      //   })
      //   commit('setEmptyMember', [])
      //   dispatch("newteam/getTeams", rootState.authen.user,{root:true})
      // },
      // checkEndingloopTeamParent({ commit, rootState, state, dispatch }: any, user: any){
      //   let teams:any = []
      //   firebase.database().ref().child('team').orderByChild('company').equalTo(`${user.company}`).once('value', (querySnapshot) => {
      //       querySnapshot.forEach((doc) => {
      //         const _team = doc.val();
      //         _team.key = doc.key;
      //         teams.push(_team);
      //       });
      //       const teamsuse = [];
      //       for(let i in teams){
      //         if(teams[i].parent){
      //           if(teamsuse[teams[i].parent] === undefined){
      //             teamsuse[teams[i].parent] = new Array();
      //           }
      //           teamsuse[teams[i].parent].push({team_id:teams[i].key});
      //         }
      //       }
      //       for(let id in teamsuse){
      //           console.log(id)
      //           console.log(globalfunc.getAllParent(teamsuse, id))
      //       }
      //   });
      // }
    },
      getters: {
        datamembers : (state:any) => {
          return state.datamembers
        },
        members : (state:any) => {
            return state.members
        },
        team : (state:any) => {
          return state.teamall
        },
        inputSearch: (state:any) => {
          return state.inputSearch
        },
        inputSearchArchive: (state:any) => {
          return state.inputSearchArchive
        },
        sizepage: (state:any) => {
          return state.size_page
        },
        dataexport : (state:any) => {
          return state.dataexport
        },
        results : (state:any) => {
          return state.results
        },
        resultsArchive : (state:any) => {
          return state.resultsArchive
        },
        page : (state:any) => {
          return state.page
        },
        pagearchive : (state:any) => {
          return state.pagearchive
        },
        modalMemberData : (state:any) => {
          return state.modalMemberData
        },
        membersByKey : (state:any) => {
          return state.membersByKey
        },
        membersArchiveByKey : (state:any) => {
          return state.membersArchiveByKey
        },
        bossByKey : (state:any) => {
          return state.bossByKey
        },
        teamByKey : (state:any) => {
          return state.teamByKey
        },
        teamParentByKey : (state:any) => {
          return state.teamParentByKey
        },
        membersArchive : (state:any) => {
          return state.membersArchive
        },
        membersArchiveAll : (state:any) => {
          return state.membersArchiveAll
        },
        incomplete : (state:any) => {
          return state.incomplete
        },
        loadingMemberTable : (state:any) => {
          return state.loadingMemberTable
        },
        loadingArchiveTable : (state:any) => {
          return state.loadingArchiveTable
        },
        loadingOrgChartView : (state:any) => {
          return state.loadingOrgChartView
        },
        webviewData : (state:any) => {
          return state.webviewData
        },
        allArchiveData : (state:any) => {
          return state.allArchiveData
        },
        managerMembers : (state:any) => {
          return state.managerMembers
        },
        orgChartView : (state:any) => {
          return state.orgChartView
        },
        riskData : (state:any) => {
          return state.riskData
        },
        loadingLoadMoreData: (state:any) => {
          return state.loadingLoadMoreData
        },
        powerData: (state:any) => {
          return state.powerData
      },
      archivedSchedule:(state:any)=>{
        return state.archivedSchedule
      },
      timeZoneOption : (state:any) => {
        return state.timeZoneOption
      },
      locationOption : (state:any) => {
          return state.locationOption
      },
      // emptyMember: (state:any) => {
      //   return state.emptyMember
      // },
      updateMember: (state:any) => {
        return state.updateMember
      },
      recognitionValue: (state:any) => {
        return state.recognitionValue
      },
      recognition: (state:any) => {
        return state.recognition
      },
      alignment: (state:any) => {
        return state.alignment
      },
      hashtag: (state:any) => {
        return state.hashtag
      },
      last_rank_given: (state:any)=>{
        return state.last_rank_given
      },
      last_rank_received: (state:any)=>{
        return state.last_rank_received
      },
      last_rank_ratio: (state:any)=>{
        return state.last_rank_ratio
      },
      personalContext: (state:any)=>{
        return state.personalContext
      }
      }
  }